const messages = {
  en: {
    general: {
      hello: 'Hello',
      ok: 'Ok',
      yes: 'Yes',
      no: 'No',
      cancel: 'Cancel',
      back: 'Back',
      scrollToTop: 'Scroll to top',
      save: 'Save',
      print: 'Print',
      loading: 'Loading...',
      homepage: 'Homepage',
      toTheHomepage: 'To the Homepage',
      toTheStartsite: 'To the Homepage',
      clear: 'Clear',
      diOverriddenDate: 'DI StandVom date is overridden. This may lead to unexpected results.',
      errors: {
        post: 'Sorry, an error occurred while sending your data',
        generic: 'Sorry, an error occurred'
      },
      textareaCharLeft: {
        of: 'of',
        characters: 'characters',
        still: 'Still',
        charsLeft: 'characters left'
      },
      versionUpdate: {
        title: 'You are using an old version of the Vattenfall Online Service',
        text: 'For everything to work correctly again: log out here, close the browser or just this tab, and open the page again.',
        button: 'Log out'
      }
    },
    validation: {
      minLength: '---{attribute} is too short. You need at least {min} characters',
      numeric: '---{attribute} needs to be a numeric value.',
      email: 'Field has to contain a valid email address.',
      regex: 'Please enter a valid value',
      dataProcessing: {
        checked: 'Please confirm that you have read and accepted the privacy policy.'
      },
      phoneNumber: {
        required: 'Phone number is required',
        length: 'Phone number has to have at least 6 digits.',
        phoneNumberFormat: 'Format of phone number is not valid.'
      },
      accountNumber: {
        required: 'Account number is required',
        length: 'Account number has to have 12 digits.',
        numeric: 'Account number can contain only digits.'
      },
      timeslot: {
        required: 'You have to select a timeslot.'
      },
      readingValue: {
        minLength: '---Input value has to be larger than provided. Please correct.',
        required: '---Input value is required',
        validatorNumericWithComma: '---Input value has to be a numeric value with maximum {beforeComma} digits before the comma and {afterComma} digits after the comma',
        validatorNumericWithoutComma: '---Input value has to be a numeric value with maximum {beforeComma} digits',
        numeric: '---Input value has to be a numeric value.'
      }
    },
    components: {
      table: {
        date: '---Datum',
        salesType: '---Umsatzart',
        amount: '---Betrag',
        status: '---Status',
        goTo: '---Abschlag ändern',
        noData: '---Keine Daten zum Anzeigen vorhanden'
      }
    },
    contractSelection: {
      headers: {
        contractSelectionHeader: 'Select Contract:'
      },
      labels: {
        selectedContract: 'Selected Contract:',
        selectContract: 'Select Contract',
        contractAccount: 'Contract Account',
        addAccount: '+ Add account',
        electricity: 'Electricity',
        gas: 'Gas',
        noncomm: 'Others'
      },
      contractStatuses: {
        ORDER_RECEIVED: 'Order received',
        ORDER_RECEIVING: 'Order receiving',
        ORDER_IN_PROGRESS: 'Order in progress',
        ORDER_COMPLETED: 'Order completed',
        INACTIVE: 'Contract inactive',
        CUSTOMER_FEEDBACK_EXPECTED: 'Customer feedback expected',
        ORDER_REJECTED: 'Order rejected',
        ORDER_CANCELED: 'Order canceled',
        MOVE_OUT: 'Move out recorded',
        ACTIVE: 'Contract active',
        OTHER: 'unknown status code',
        undefined: ''
      }
    },
    contactForm: {
      header: 'Contact us',
      subheader: 'Send us your request. Our service staff will contact you as soon as possible. A copy of the form you submitted will be send to your e-mail address.',
      contactReason: 'Subject',
      message: 'Your message',
      attachDocument: 'Your documents',
      attachDocumentHint: 'You may add a file attachment up to 10 MB to your message. You may upload in any of the following file formats: pdf, doc, docx, xls, xlsx, jpg, gif, png, zip.',
      areYouACustomer: 'Haben Sie ein Anliegen zu einem bereits abgeschlossenen Vertrag?',
      personalData: 'Personal data',
      salutation: 'Form of address',
      firstname: 'First name',
      lastname: 'Family name',
      companyName1: 'Company name',
      companyName2: 'Company name addition',
      contractAccountNumber: 'Contract account number',
      email: 'E-Mail',
      phone: 'Daytime telephone',
      zipcode: 'Post code',
      agreement: 'I confirm, that I have read the notes on <a class="standard-link" target="_blank" href="//vattenfall.de/datenschutz">data protection</a> and accept them.',
      cancel: 'Cancel',
      submit: 'Send',
      attachment: 'Attachment',
      confirmation: 'Confirmation',
      requestSent: 'Following request was sent to our support service:',
      contactInfo: 'Thanks for your message. We will process your request as quickly as possible.',
      validations: {
        attachment: {
          fileSizeValidator: 'Attachments must not exceed 10 MB.',
          fileTypes: 'The format of attached file is wrong. Allowed formats: pdf, doc, docx, xls, xlsx, jpg, gif, png, zip. '
        },
        contactReason: {
          required: 'Please select.'
        },
        message: {
          required: 'Please fill in this field.'
        },
        salutation: {
          required: 'Please select.'
        },
        contractAccountNumber: {
          regex: 'The contract account number must contain 12 digits and start with 83.'
        },
        email: {
          email: 'Please enter a valid e-mail address.<br />For example: <strong>mustermann@mustermail.com</strong>',
          required: 'Please enter a valid e-mail address.<br />For example: <strong>mustermann@mustermail.com</strong>'
        },
        phone: {
          phoneNumberFormat: 'Please enter a valid phone number.'
        },
        zipcode: {
          regex: 'Please enter a valid post code.'
        },
        agreement: {
          checked: ''
        }
      }
    },
    navigation: {
      labels: {
        DASHBOARD: 'Dashboard',
        USER_PROFILE: 'User profile',
        ACCOUNT_OVERVIEW: 'Account overview',
        CONSUMPTION_OVERVIEW: 'Consumption overview',
        CONTRACT_OVERVIEW: 'Contract overview',
        TELL_A_FRIEND: 'Tell a friend',
        FAQ: 'FAQ',
        ANGEBOTE: 'Offers',
        undefined: ''
      },
      mobileHome: 'Home',
      mobileMenu: 'Menu',
      mobileFaq: 'FAQ'
    }
  },
  de: {
    general: {
      loggedInAs: 'Angemeldet als',
      ok: 'Weiter',
      next: 'Weiter',
      cancel: 'Abbrechen',
      submitOrder: 'Abbrechen',
      yes: 'Ja',
      no: 'Nein',
      back: 'Zurück',
      send: 'Senden',
      here: 'hier',
      scrollToTop: 'Nach oben',
      save: 'Speichern',
      print: 'Drucken',
      printButton: 'Zusammenfassung drucken',
      required: 'Pflichtfeld',
      requiredLong: 'Felder mit * sind Pflichtfelder und müssen ausgefüllt werden',
      loading: '---Loading...',
      homepage: 'Homepage',
      toTheHomepage: 'Zur Übersicht',
      toTheStartsite: 'Zur Startseite',
      toTheLogin: 'Zum Login',
      clickToShowPassword: 'Klicken Sie, um das Passwort anzuzeigen',
      clickToHidePassword: 'Klicken Sie, um das Passwort zu verbergen',
      noData: 'keine Rückmeldung',
      showMoreRows: 'Archiv',
      edit: 'Ändern',
      editAlt: 'Bearbeiten',
      sentData: 'Gesendete Daten',
      clear: 'Löschen',
      ipBlocked: 'Ihr Zugang wurde aus Sicherheitsgründen vorübergehend gesperrt. Bitte versuchen Sie es nach 24 Stunden erneut.',
      help: 'Kontakt',
      vattenfallHomePage: 'Vattenfall Homepage',
      meinVattenfall: 'Mein Vattenfall',
      login: 'Anmelden',
      logout: 'Abmelden',
      diOverriddenDate: 'DI StandVom date is overridden. This may lead to unexpected results.',
      dearVisitor: 'Sehr geehrter Besucher',
      wrongDate: 'Die Zeit auf Ihrem Gerät weicht von der Zeitzone in Deutschland ab. Damit Datums- und Zeitangaben richtig dargestellt werden, passen Sie bitte die Systemzeit in den Einstellungen Ihres Gerätes an.',
      footnote: 'Fußnote ',
      footnotes: 'Fußnoten',
      errors: {
        post: 'Beim Senden Ihrer Daten ist ein Fehler aufgetreten',
        generic: 'Entschuldigung, ein Fehler ist aufgetreten',
        unexpected: 'Leider ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.'
      },
      textareaCharLeft: {
        still: 'Noch',
        of: 'von',
        characters: 'Zeichen',
        charsLeft: 'Zeichen verfügbar'
      },
      labels: {
        zipcode: 'Postleitzahl',
        city: 'Ort',
        street: 'Straße',
        houseNo: 'Nr.',
        co: 'c/o'
      },
      salutation: {
        herr: 'Sehr geehrter Herr {surname}',
        herrn: 'Sehr geehrter Herr {surname}',
        frau: 'Sehr geehrte Frau {surname}',
        damen: 'Sehr geehrte Damen und Herren',
        herren: 'Sehr geehrte Damen und Herren',
        kundin: 'Sehr geehrte Kundin / Sehr geehrter Kunde',
        firma: 'Sehr geehrte Damen und Herren',
        ohne: 'Sehr geehrte Damen und Herren '
      },
      postBoxHint: 'Sollte Ihr Name nicht am Briefkasten stehen, können Sie hier den Namen auf dem Briefkasten eintragen.',
      addressNotFound: 'Die Straße wurde unter der eingegebenen Postleitzahl nicht gefunden. Bitte überprüfen Sie Ihre Eingabe und bestätigen Sie mit "Weiter".',
      cityNotFound: 'Die Stadt wurde unter der eingegebenen Postleitzahl nicht gefunden.',
      captcha: {
        title: 'Ihre Daten werden geprüft',
        subtitle: 'Wir prüfen Ihre Eingabe und sind gleich für Sie da'
      },
      versionUpdate: {
        title: 'Sie nutzen eine alte Version des Vattenfall Online Service',
        text: 'Damit alles wieder richtig funktioniert: Loggen Sie sich hier aus, schließen Sie den Internet-Browser oder nur diesen Tab und öffnen Sie die Seite neu.',
        button: 'Ausloggen'
      },
      validations: {
        zipcode: {
          required: 'Bitte füllen Sie dieses Feld aus.',
          length: 'Bitte geben Sie 5 Ziffern ein.',
          empty: 'Zu der angegebenen Postleitzahl konnten keine Orte ermittelt werden.',
          selected: 'Bitte wählen Sie eine Stadt aus der Liste aus.',
          blacklist: 'Die angegebene Postleitzahl gehört nicht zu unserem Liefergebiet.'
        }
      }
    },
    validation: {
      minLength: '---{attribute} is too short. You need at least {min} characters',
      numeric: '---{attribute} needs to be a numeric value.',
      email: 'Der Wert muss eine gültige E-Mail-Adresse sein.',
      regex: '---Please enter a valid value',
      marketlocationsId: 'Hinweis: Zu Ihrer Eingabe wurde eine Marktlokations-ID gefunden. Überprüfen Sie bitte Ihre Eingabe oder klicken Sie auf Weiter, um die Marktlokations-ID zu bestätigen.',
      dataProcessing: {
        checked: 'Bitte bestätigen Sie, dass Sie die Informationen zum Datenschutz gelesen und akzeptiert haben.'
      },
      phoneNumber: {
        required: 'Telefonnummer ist ein Pflichtfeld.',
        length: 'Telefonnummer muss mindestens 6 Zeichen lang sein.',
        phoneNumberFormat: 'Das Format der Telefonnummer ist ungültig.'
      },
      accountNumber: {
        required: 'Vertragskontonummer ist ein Pflichtfeld',
        length: 'Vertragskontonummer muss mindestens 12 Zeichen lang sein.',
        numeric: 'Vertragskontonummer darf nur numerische Zeichen enthalten.'
      },
      timeslot: {
        required: 'Zeitraum ist ein Pflichtfeld.'
      },
      readingValue: {
        minLength: '---Input value has to be longer than provided. Please correct.',
        required: '---Input value is required',
        validatorNumericWithComma: '---Input value has to be a numeric value with maximum {beforeComma} digits before the comma and {afterComma} digits after the comma',
        validatorNumericWithoutComma: '---Input value has to be a numeric value with maximum {beforeComma} digits',
        numeric: '---Input value has to be a numeric value.'
      },
      sendData: {
        participationAgreed: {
          checked: 'Bitte bestätigen Sie, dass Sie die Informationen zum Datenschutz gelesen und akzeptiert haben.'
        },
        name: {
          required: 'Bitte geben Sie einen Vornamen ein.',
          pattern: 'Bei der Eingabe Ihres Vornamens sind nur Buchstaben erlaubt.'
        },
        surname: {
          required: 'Bitte geben Sie einen Nachnamen ein.',
          pattern: 'Bei der Eingabe Ihres Nachnamens sind nur Buchstaben erlaubt.'
        }
      }
    },
    components: {
      accountOverview: {
        header: 'Zahlungsübersicht',
        period: 'Abrechnungszeitraum',
        currentBalance: 'Aktueller Saldo',
        deliveryPoint: 'Lieferstelle',
        description: 'Buchungstext',
        dueDate: 'Fälligkeitsdatum',
        paidDate: 'Belegdatum',
        dueAmount: 'Forderung',
        paidAmount: 'Haben',
        goTo: 'Zurück zur Übersicht',
        toPaymentData: 'Zu den Bezahldaten',
        toInvoices: 'Zu den Rechnungen',
        partPayment: 'Abschlag ändern',
        showMore: 'Mehr anzeigen',
        noData: 'Keine Daten zum Anzeigen vorhanden.',
        processUnavailable: 'Für dieses Vertragskonto stehen zur Zeit keine Kontoumsätze zur Verfügung.',
        hint: {
          title: 'Hinweis zu offenen Forderungen',
          text: 'Ihr Konto weist aktuell eine oder mehrere offene Forderungen auf. Gleichen Sie daher bitte die Gesamtforderung unverzüglich aus, um zusätzliche Kosten zu vermeiden. Weitere Informationen dazu finden Sie in der Kontoübersicht oder in <a class="standard-link" href="/postfach">Ihren Rechnungen</a>.'
        }
      }
    },
    tellAFriend: {
      headers: {
        title: 'Freunde werben',
        main: 'Tarif empfehlen und Prämie sichern',
        subHeader: 'Die Prämie erhalten Sie für jeden Kunden, der aufgrund Ihrer Empfehlung einen unserer Tarife abschließt.'
      },
      tables: {
        headers: {
          advertisedFriends: 'Status Ihrer geworbenen Freunde',
          sentAdvertisingMails: 'Übersicht Ihrer Empfehlungen'
        },
        labels: {
          productOrderedOn: 'Produkt bestellt am',
          friendName: 'Name',
          processStatus: 'Verarbeitungsstatus',
          wantedOnDate: 'Geworben am',
          receiverName: 'Name Empfänger',
          receiverMail: 'E-Mail Empfänger',
          noRespondRow: 'keine Rückmeldung'
        }
      },
      form: {
        headerRadio: 'Empfehlen Sie unsere Tarife',
        headerInputs: 'Daten Ihres Freundes',
        radioLabelGas: 'Gas',
        radioLabelElectricity: 'Strom',
        nameLabel: 'Vorname',
        surnameLabel: 'Name',
        checkboxDataProcessingPart1: 'Ich akzeptiere die ',
        checkboxDataProcessingPart2: ' für Freunde werben Freunde.',
        maxSubmitsMessage1: 'Sie können maximal ',
        maxSubmitsMessage2: ' Einladungen pro Tag versenden.'
      },
      thankYouPage: {
        header: 'Vielen Dank für Ihre Teilnahme am Programm Freunde werben Freunde.',
        nextSteps: 'Die nächsten Schritte',
        pointOne: 'Sie erhalten in den nächsten Minuten eine E-Mail von uns.',
        pointTwo: 'Sie können diese E-Mail direkt oder auch nur den enthaltenen Link über einen Kanal Ihrer Wahl an Ihren Freund senden.',
        pointThree: 'Ihr Freund kann die Bestellung über den Button in der E-Mail oder den Link starten.',
        pointFour: 'Nachdem die Bestätigung des Liefertermins bei Ihrem Freund eingegangen ist bekommen Sie Ihre Prämie gutgeschrieben.',
        overviewYourActivities1: 'Eine Übersicht Ihrer Aktivitäten finden Sie',
        overviewYourActivities2: 'hier',
        participateInLottery: 'Ich nehme am Gewinnspiel teil.',
        product: 'Empfohlene Tarife für',
        productGas: 'Gas',
        productElectricity: 'Strom'
      },
      circle: {
        bonus: 'Prämie'
      },
      listCheck: {
        checkOne: 'Auswählen, ob Sie einen Strom- oder Gasvertrag empfehlen möchten',
        checkTwo: 'Den Namen der Freunde eintragen',
        checkThree: 'Und die Teilnahmebedingungen akzeptieren'
      },
      btns: {
        conditionsOfParticipation: 'Teilnahmebedingungen',
        advertiseFriend: 'Freunde werben'
      }
    },
    consumptionOverview: {
      header: 'Verbrauchsübersicht',
      errors: {
        noData: ' Für das ausgewählte Vertragskonto ist derzeit keine Verbrauchsübersicht verfügbar.',
        noPermission: 'Für das ausgewählte Vertragskonto ist derzeit keine Verbrauchsübersicht verfügbar.',
        disabled: 'Für das ausgewählte Vertragskonto ist derzeit keine Verbrauchsübersicht verfügbar.',
        general: 'Entweder haben Sie keine Berechtigung zur Anzeige der Verbrauchsübersicht oder es liegt eine technische Störung vor.'
      },
      tables: {
        headers: {
          yourCounts: 'Verbrauchsübersicht'
        },
        labels: {
          date: 'Datum',
          meterNumber: 'Zählernummer',
          meterReading: 'Zählerstand',
          consumption: 'Verbrauch',
          reason: 'Ablesegrund',
          type: 'Ableseart'
        },
        gasLegend: '* wird mittels Zustandszahl und Brennwert errechnet'
      },
      chart: {
        labels: {
          GAS: {
            lastConsumptions: 'Ihr Jahresgasverbrauch in kWh',
            averageConsumptions: 'Durchschnittlicher Jahresgasverbrauch in kWh'
          },
          STROM: {
            lastConsumptions: 'Ihr Jahresstromverbrauch',
            averageConsumptions: 'Durchschnittlicher Jahresstromverbrauch'
          },
          consumption: 'Verbrauch in kWh',
          approximateConsumption: '* gerechnet auf 365 Tage',
          invoice: 'Abrechnung'
        },
        tooltips: {
          gasConsumptionInKWH: 'Zählerstände werden bei Gas in Kubikmeter m<sup>3</sup> abgelesen. Diese werden dann in verbrauchte Arbeit kWh umgerechnet. Die nötigen Werte dazu liefert uns Ihr örtlicher Netzbetreiber.',
          approximateConsumption: 'Bitte beachten Sie, dass der Wert Ihrer Abrechnung in der Grafik von Ihrer Jahresrechnung abweichen kann. Um Ihnen eine Vergleichbarkeit zu ermöglichen rechnen wir Ihren Verbrauch auf ein ganzes Jahr um.'
        }
      }
    },
    contractSelection: {
      headers: {
        contractSelectionHeader: 'Vertragskonto wechseln',
        contractNumber: 'Vertragskontonummer:',
        product: 'Produkt',
        address: 'Lieferstelle',
        status: 'Status',
        accountNumber: 'Vertragskonto-Nr.'
      },
      labels: {
        selectContract: 'Ausgewählter Vertrag:',
        contractAccount: 'Vertragskonto',
        addAccount: 'Bestehenden Vertrag hinzufügen',
        electricity: 'Strom',
        gas: 'Gas'
      },
      contractStatuses: {
        ORDER_RECEIVED: 'Bestellung eingegangen',
        ORDER_RECEIVING: 'Bestellung erhalten',
        ORDER_IN_PROGRESS: 'Bestellung in Bearbeitung',
        ORDER_COMPLETED: 'Bestellung abgeschlossen',
        INACTIVE: 'Vertrag inaktiv',
        CUSTOMER_FEEDBACK_EXPECTED: 'Kundenrückmeldung erwartet',
        ORDER_REJECTED: 'Bestellung abgelehnt',
        ORDER_CANCELED: 'Bestellung abgebrochen',
        MOVE_OUT: 'Auszug erfasst',
        ACTIVE: 'Vertrag aktiv',
        OTHER: 'unbekannter Vertragsstatus',
        undefined: ''
      }
    },
    meterReading: {
      meterUnits: {
        KWH: 'kWh',
        STROM: 'kWh',
        GAS: 'm<sup>3</sup>',
        M3: 'm<sup>3</sup>'
      },
      headers: {
        headerForBanner: 'Zählerstandserfassung',
        formElectricityMeterNumber: 'Stromzählernummer',
        formGasMeterNumber: 'Gaszählernummer',
        marketlokationsId: 'Marktlokations-ID',
        modBoxLastMeterReading: 'Meine letzten Zählerstände',
        sentThankYou: 'Vielen Dank, wir haben Ihren Zählerstand erhalten.',
        TURNUSABLESUNG: 'Zählerstand für Ihre Jahresverbrauchsabrechnung',
        AUSZUGABLESUNG: 'Zählerstand für Ihre Schlussrechnung',
        EINZUGABLESUNG: 'Zählerstand für Ihren Vertragsbeginn',
        lastReadingLabel: 'Letzte Ablesung',
        htLastReading: '{value} {unit} (HT) vom {date}',
        ntLastReading: 'und {value} {unit} (NT) vom {date}',
        overview: 'Zählerstandsübersicht',
        default: 'Neuen Zählerstand erfassen',
        readingInText: 'Zählerstandsdaten in das Textfeld eintragen'
      },
      labels: {
        reasonTableHeader: 'Ablesegrund',
        typeTableHeader: 'Ableseart',
        meterReadingTableHeader: 'Zählerstand',
        formDate: 'Ablesedatum',
        formMeterNumber: 'Zählernummer',
        contractAccountNumber: 'Vertragskontonummer',
        formReason: 'Begründung',
        historyDate: 'Datum',
        meterReading: 'Zählerstand ohne Nachkommastelle',
        meterReadingShort: 'Zählerstand ohne Nachkomma',
        consumption: 'Verbrauch',
        abbrevHT: '(HT)',
        abbrevNT: '(NT)',
        reason: 'Ablesegrund',
        photoUploadTitle: 'Foto des Zählerstands hochladen (optional)',
        photoUploadInstruction: 'Hier klicken oder Datei ablegen',
        photoUploadInfo: 'Auf dem Foto Ihres Zählers sollte sowohl der Zählerstand als auch die Zählernummer erkennbar sein.',
        photoUploadRemove: 'Foto löschen',
        photoUploaded: 'Ihr Foto wurde erfolgreich hochgeladen',
        readingInText: 'Zählerstandsdaten',
        readingInTextInfo: 'Teilen Sie uns hier Ihren Zählerstand ohne Nachkommastellen und das zugehörige Ablesedatum für den oben angezeigten Zähler mit.'
      },
      implausibleReasons: {
        ZAEHLERSTAND_KORREKT: 'Zählerstand ist korrekt',
        WASSERSCHADEN: 'Wasserschaden',
        ZAEHLERTAUSCH: 'Zähler wurde ausgetauscht'
      },
      messages: {
        sentThankYou: 'In wenigen Minuten erhalten Sie eine Bestätigung per E-Mail.',
        readingOpenSentThankYou: 'Sofern Sie bei uns eine E-Mail-Adresse hinterlegt haben, erhalten Sie in wenigen Minuten eine Bestätigung per E-Mail.',
        sentThankYouMandateNotice: 'Sollten Sie eine weitere Aufforderung zur Ablesung erhalten, betrachten Sie diese als gegenstandslos.',
        noReadingFieldsInfo: 'Die Standard-Zählerstandserfassung ist bei diesem Vertrag aktuell nicht möglich. Bitte schreiben Sie Ihre Zählerstandsdaten in das Textfeld.'
      },
      tooltips: {
        STROM: 'Tragen Sie hier bitte nur die Ziffern vor dem Komma auf Ihrem Zähler ein und ignorieren Sie alle Nachkommastellen. Bei einem Zweirichtungszähler tragen Sie bitte nur den Wert <strong>1.8.0</strong> für den Strombezug ein.',
        GAS: 'Bitte tragen Sie hier nur die Ziffern vor dem Komma auf Ihrem Gaszähler ein und ignorieren Sie alle Nachkommastellen.',
        OBIS_SINGLE: 'Tragen Sie hier bitte nur die Ziffern vor dem Komma auf Ihrem Zähler ein und ignorieren Sie alle Nachkommastellen. Bei einem Zweirichtungszähler tragen Sie bitte nur den Wert 1.8.0 für den Strombezug ein.',
        OBIS_HT: 'Tragen Sie hier den Wert für den Strombezug im Hochtarif (HT) mit der OBIS-Kennziffer 1.8.1 ein. Geben Sie bitte nur die Ziffern vor dem Komma auf Ihrem Zähler ein, Nachkomma-stellen werden nicht benötigt.',
        OBIS_NT: 'Tragen Sie hier den Wert für den Strombezug im Niedertarif (NT) mit der OBIS-Kennziffer 1.8.2 ein. Geben Sie bitte nur die Ziffern vor dem Komma auf Ihrem Zähler ein, Nachkomma-stellen werden nicht benötigt.',
        OBIS: 'Hinweis: Lesen Sie bitte nur den Wert 1.8.X (für Bezug) ab. Den Wert der Einspeisung 2.8.X (z.B. durch eine Photovoltaik-Anlage) brauchen wir nicht. Die Abrechnung der Einspeisung erfolgt über Ihren Netzbetreiber.',
        contractAccountNumber: 'Ihre Vertragskontonummer finden Sie z.B. jeweils im grau hinterlegten Bereich Ihrer Vertragsbestätigung sowie Ihrer Rechnung.',
        formMeterNumber: 'Die Zählernummer finden Sie auf Ihrer Vertragsbestätigung oder Ableseaufforderung sowie Ihren Rechnungen. Natürlich finden Sie diese auch immer auf Ihrem Zähler, häufig in der Nähe des Barcodes.'
      },
      buttons: {
        consumptionOverview: 'Zur Verbrauchsübersicht',
        showAllReadings: 'Alle Zählerstände anzeigen'
      },
      validationsReadingValue: {
        required: 'Bitte geben Sie Ihren Zählerstand ein.'
      },
      validationsDate: {
        required: 'Bitte geben Sie das Datum im Format TT.MM.JJJJ ein.',
        min: 'Bitte geben Sie ein Datum ab dem {value} ein.',
        max: 'Bitte geben Sie ein Datum bis einschließlich {value} ein.'
      },
      validationUploadFile: {
        error: 'Dieses Bild kann nicht verarbeitet werden. Bitte versuchen Sie es mit einem anderen.'
      },
      validationsImplausibleReason: {
        required: 'Bitte füllen Sie dieses Feld aus.'
      },
      validationsMeterNumber: {
        required: 'Bitte geben Sie Ihre Zählernummer ein.',
        Format: 'Die Zählernummer dameterNumberrf keine Leerzeichen oder Fragezeichen enthalten.'
      },
      validationsAccountNumber: {
        required: 'Geben Sie eine 12-stellige Vertragskontonummer beginnend mit 83 ein.',
        contractAccountNumberFormat: 'Ihre Vertragskontonummer besteht nur aus Ziffern und beginnt mit 83.'
      },
      validationsReadingInText: {
        required: 'Bitte füllen Sie dieses Feld aus.'
      },
    },
    optin: {
      title: 'Änderung Ihrer Werbeeinverständnisse',
      banner: 'Werbeeinstellungen',
      subtitle: 'Hier haben Sie die Möglichkeit, Anpassungen bezüglich Ihres Werbeeinverständnisses vorzunehmen.',
      headline: 'Sie haben folgende Benachrichtigungen per E-Mail abonniert',
      headlineEdit: 'Wählen Sie News und Angebote nach Ihren Interessen',
      text0: '<h4>Produkte und Kundenbefragungen</h4>',
      text1: '<h4>News und Kundenvorteile</h4>',
      text2: '<h4>Business News und Angebote</h4>',
      textRobinson: '<h4>Keine Werbung</h4><p>Ich möchte unter dieser Geschäftspartnernummer grundsätzlich keine Werbung von Vattenfall erhalten.</p>',
      cancel: 'Zurück',
      submit: 'Speichern',
      edit: 'Werbeeinstellungen bearbeiten',
      errorNoSelection: 'Bitte wählen Sie mindestens eine Checkbox aus.',
      thanks: 'Vielen Dank, der Auftrag zur Änderung Ihrer Werbeeinstellungen ist bei uns eingegangen.',
      confirm: 'Sie erhalten in Kürze eine E-Mail von uns. Klicken Sie dort auf „Bestätigen“, um die Änderung abzuschließen.',
      thanksHeader: 'Wie geht es weiter?',
      thanksMsg0: 'Sobald Sie in der Mail Ihren Änderungswunsch bestätigt haben, werden die Werbeeinstellungen angepasst.',
      thanksMsg1: 'Es kann einige Minuten dauern, bis die Änderung wirksam wird.',
      thanksMsg2: 'Bitte haben Sie Verständnis, falls Sie noch vereinzelt Werbung von uns erhalten. Diese kann sich mit der Bearbeitung Ihres Werbewiderspruchs überschnitten haben.',
      subscribed: 'abonniert',
      not: 'nicht'

    },
    statusPage: {
      headers: {
        hintPage: 'Wartungsarbeiten',
        disabledPage: 'Nicht verfügbar'
      },
      messages: {
        hintMessage1: 'Der von Ihnen ausgewählte Prozess steht aufgrund von Wartungsarbeiten ',
        hintMessage2: ' leider nicht zur Verfügung. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
        disabledPage: 'Entweder haben Sie keine Berechtigung zur Ausführung dieses Prozesses oder es liegt eine technische Störung vor. Bitte entschuldigen Sie die Umstände. Vielen Dank.'
      }
    },
    login: {
      sessionLostMessage: 'Weil Sie lange nicht aktiv waren, wurden Sie aus Sicherheitsgründen ausgeloggt.',
      accountLogoutTitle: 'Sie wurden von Ihrem Onlinekonto abgemeldet',
      accountLogoutMessage: 'Da Sie in Ihrem Onlinekonto Ihre E-Mail-Adresse geändert haben, wurden Sie aus Sicherheitsgründen abgemeldet. Melden Sie sich bitte mit Ihrer neuen E-Mail-Adresse als Benutzernamen und Ihrem Passwort wieder an.',
      accountDeletedMessage: 'Sie wurden erfolgreich deregistriert.',
      registration: 'Sie haben noch kein Online-Konto?',
      title: {
        main: 'Anmeldung zum Online Service',
        subtitle: 'Sie kennen Mein Vattenfall noch nicht?',
        link: 'Mehr erfahren',
        mainMobile: 'Anmeldung <br /> zum Online Service',
        justPassword: 'Anmeldung',
        withPassword: 'Mit Passwort',
        instructionToLoginWithPassword:'Melden Sie sich mit Ihren Zugangsdaten an.',
        instructionToLoginWithoutPassword: 'Sie erhalten eine E-Mail zum Anmelden.',
        withLink: 'Ohne Passwort',
        justLink: 'Login-Link',
        sentLink: 'Login-Link erfolgreich versendet',
        termsAndConditions: 'Allgemeine Geschäftsbedingungen',
        faq: 'Fragen & Antworten',
        termsAndConditionsCancel: 'Wie geht es ohne Zustimmung zu den neuen Nutzungsbedingungen weiter?'
      },
      buttons: {
        login: 'Jetzt anmelden',
        send: 'E-Mail anfordern',
        forgottenPassword: 'Passwort vergessen?',
        register: 'Hier registrieren',
        tacReject: 'Ablehnen',
        tacAccept: 'Akzeptieren',
        tacPrint: 'Dokument drucken',
        tacDownload: 'Dokument herunterladen',
        tacPdfFilename: 'Nutzungsbedingungen',
        back: 'E-Mail erneut anfordern'
      },
      labels: {
        username: 'Benutzername oder E-Mail-Adresse',
        usernameOnly: 'Benutzername',
        password: 'Passwort',
        meterNumber: 'Zählernummer',
        termsAndConditionsCancel: 'Zurück zu den Nutzungsbedingungen',
        termsAndConditionsDeny: 'Online-Account löschen'
      },
      validations: {
        username: {
          required: 'Bitte geben Sie Ihre E-Mail-Adresse oder Ihren Benutzernamen an.'
        },
        password: {
          required: 'Bitte geben Sie Ihr Passwort an.'
        }
      },
      tooltips: {
        password: 'Das Auge im Eingabefeld ermöglicht die Anzeige des Passworts in Klarschrift.'
      },
      texts: {
        infoIconText: 'Geben Sie hier Ihre E-Mail-Adresse oder Ihren Benutzernamen ein. Nachdem Sie auf „E-Mail anfordern“ geklickt haben, erhalten Sie eine E-Mail, mit der Sie sich bequem einloggen können. Falls Sie mehrere Kundenkonten mit derselben E-Mail-Adresse haben, müssen Sie hier den jeweiligen Benutzernamen eintragen.',
        withLinkMoreInfo: 'Sie erhalten eine E-Mail zum Einloggen.',
        sentLinkHeader: 'Prüfen Sie bitte Ihre E-Mails.',
        sentLink: 'Wir haben einen Login-Link an folgende E-Mail-Adresse gesendet. Dieser ist nur einmalig und für die Dauer einer Stunde gültig.',
        termsAndConditionsWarning: 'Falls Sie den Nutzungsbestimmungen nicht zustimmen möchten, werden Sie nicht mehr online auf Ihre Vertragsdokumente und Schreiben zugreifen können und müssen Ihren Online-Account löschen.',
        termsAndConditionsPoint1: 'Wenn Sie bei Ihrer Entscheidung bleiben, müssen Sie Ihren Online-Account jetzt löschen, damit Sie zukünftige Vertragsdokumente und Schreiben ausschließlich per Post erhalten.',
        termsAndConditionsPoint2: 'Nach der Löschung Ihres Online-Accounts können Sie Ihre gesamten online hinterlegten Vertragsdokumente und Schreiben sichern. Dazu senden wir Ihnen nach der Löschung Ihres Online-Service-Accounts eine E-Mail mit einem Link.'
      },
      withLinkError: 'Das hat leider nicht funktioniert, der Login-Link ist ungültig.<br />Bitte loggen Sie sich mit Ihrem Benutzernamen und Ihrem Passwort ein.',
      genericError: 'Aufgrund technischer Probleme ist ein Login derzeit nicht möglich. Bitte versuchen Sie es später noch einmal.'
    },
    communicationApproval: {
      header: 'Nur noch wenige Klicks bis zur Bestellung',
      errors: {
        server: 'Entschuldigung, das hat leider nicht funktioniert. Bitte versuchen Sie es später erneut.',
        checked: 'Geben Sie uns bitte Ihre Zustimmung, ansonsten kommt der Vertrag nicht zustande.'
      },
      rejectBtn: 'Ablehnen',
      btn: 'Jetzt kostenpflichtig bestellen'
    },
    partPayment: {
      form: {
        header: 'Abschlag ändern',
        subheader: 'Passen Sie Ihren Abschlag in den Grenzen zwischen <strong>{minimum} €</strong> und <strong>{maximum} €</strong> an.',
        suggestion: 'Unsere Empfehlung',
        selectSuggestion: 'Empfehlung annehmen',
        customSelection: 'Der Wert wurde übernommen',
        suggestionFootnote: 'Bitte beachten Sie, dass der Abschlag stets nur auf einer Schätzung Ihres Verbrauchs in der laufenden Verbrauchsperiode beruhen kann. Die vorgeschlagene Anpassung der Abschlagshöhe ist ausschließlich eine Empfehlung. Unsere Empfehlung beruht auf den letzten verfügbaren Ablesedaten und berücksichtigt die tatsächlichen Verhältnisse Ihres Energiebezugs in der laufenden Verbrauchsperiode.',
        min: 'min.',
        max: 'max.',
        perMonth: '€ / Monat',
        validation: {
          withinConstraints: 'Ihre Eingabe liegt außerhalb der erlaubten Grenzen. Solche Änderungen sind nur in Ausnahmefällen und im {link} mit unserem Serviceteam möglich.',
          notTheSame: 'Der eingegebene Betrag ist identisch mit dem aktuellen Abschlag. Keine Änderung notwendig.',
          required: 'Bitte füllen Sie dieses Feld aus.',
          min: 'Bitte geben Sie ein Datum ab dem {value} ein.',
          max: 'Bitte geben Sie ein Datum bis einschließlich {value} ein.'
        },
        infoIcon: 'Warum es diese Grenzen gibt und weitere Fragen beantworten wir Ihnen <a class="standard-link" onclick="document.querySelector(\'.cso-faq\')?.scrollIntoView()">in unserem FAQ</a>.'
      },
      sentPage: {
        header: 'Vielen Dank. Wir haben den Änderungswunsch zu Ihrer Abschlagszahlung erhalten.',
        newPlan: 'Neuer Abschlag:',
        perMonth: '€ pro Monat',
        message: 'In wenigen Minuten erhalten Sie eine Bestätigung per E-Mail.'
      },
      table: {
        header: 'Abschlagsplan und Fälligkeiten',
        subheader: 'Ihre nächsten Abschlagszahlungen von monatlich {current} sind fällig am:',
        labels: {
          date: 'Datum',
          status: 'Status'
        }
      },
      errors: {
        noPlanAvailable: 'Im Moment ist kein Abschlagsplan für Ihr Vertragskonto vorhanden.',
        noOpenItems: 'Eine Änderung des Abschlagsplans für ihr Vertragskonto ist im Moment nicht möglich. ',
        blockedByRecentChange: 'Ihre Abschläge wurden vor kurzem angepasst. Deshalb ist eine Änderung zur Zeit nicht möglich.',
        badSolvency: 'Nicht verfügbar',
        general: 'Entweder haben Sie keine Berechtigung zur Anzeige der Verbrauchsübersicht oder es liegt eine technische Störung vor.'
      }
    },
    navigation: {
      labels: {
        DASHBOARD: 'Übersicht',
        USER_PROFILE: 'Persönliche Daten',
        ACCOUNT_OVERVIEW: 'Kontoübersicht',
        CONSUMPTION_OVERVIEW: 'Verbrauchsübersicht',
        CONTRACT_OVERVIEW: 'Vertrag & Umzug',
        TELL_A_FRIEND: 'Freunde werben',
        FAQ: 'Fragen & Antworten',
        ANGEBOTE: 'Angebote',
        undefined: ''
      },
      mobileHome: 'Home',
      mobileMenu: 'Menü',
      mobileFaq: 'FAQ'
    },
    personalData: {
      header: 'Persönliche Daten',
      settings: 'Persönliche Einstellungen',
      advertising: 'Werbeeinstellungen',
      communication: 'Online-Kommunikation',
      tokenOverview: 'Sitzungen abmelden',
      deleteAccount: 'Online Account löschen',
      deleteThisAccount: 'Dieses Benutzerprofil löschen?',
      deleteThisAccountLink: 'Löschen',
      deleteAccountInfoIcon: 'Hier können Sie diesen Online-Zugang endgültig löschen. Falls Sie diesen Zugang für den Online Service neu angelegt haben und beim Hinzufügen Ihres Vertrags die Fehlermeldung „Dieser Geschäftspartner ist bereits einem Kunden-Account zugeordnet.“ erschienen ist, existiert noch ein weiteres Online-Konto von Ihnen in unserem System, dem Ihr Vertrag automatisch oder von Ihnen zugeordnet wurde. Sie sollten dann das Online-Konto hier löschen und sich in Ihrem früheren Online-Zugang anmelden. Wenn Sie Ihren früheren Benutzernamen kennen, können Sie mit der Funktion „Passwort vergessen“ Ihre Zugangsdaten wieder herstellen. Haben Sie keine Möglichkeit mehr darauf zuzugreifen, kontaktieren Sie unseren Kundenservice für weitere Hilfe.',
      password: {
        header: 'Passwort',
        subHeader: 'Wir haben eine E-Mail mit einem Code an Ihre E-Mail-Adresse geschickt. Bitte tragen Sie diesen Code hier ein und vergeben Sie ein neues Passwort.',
        change: 'Passwort anpassen',
        changed: 'Ihr Passwort wurde erfolgreich geändert.',
        labels: {
          new: 'Neues Passwort',
          code: '8-stelliger Code'
        },
        hints: {
          code: 'Der 8-stellige Code bestehend aus Großbuchstaben und Zahlen. Dieser wird Ihnen innerhalb weniger Minuten per E-Mail zugesandt. Falls Sie mehrere Codes angefordert haben, verwenden Sie immer den zuletzt zugesandten Code. Vorherige Codes werden ungültig. Wenn Sie in Ihrem E-Mail-Postfach keine E-Mail mit dem Betreff „Passwort zurücksetzen oder ändern“ finden, schauen Sie bitte in Ihrem Spam-Ordner nach.'
        },
        validations: {
          passwordNew: {
            required: 'Bitte wählen Sie ein Passwort.',
            valid: 'Das Passwort muss zwischen 10 und 35 Zeichen lang sein.'
          },
          code: {
            required: 'Code ist erforderlich.'
          }
        }
      },
      contact: {
        header: 'Kontaktdaten',
        change: 'Kontaktdaten anpassen',
        title: 'Hier können Sie ihre Kontaktdaten anpassen',
        emailHint: 'Beachten Sie bitte: Die Änderung der E-Mail-Adresse ist gleichzeitig die Änderung Ihres Benutzernamens. Wenn Sie diese Änderung durchführen, werden Sie aus Sicherheitsgründen abgemeldet. Ab dem nächsten Login ist Ihre neue E-Mail-Adresse Ihr neuer Benutzername.',
        phoneHint: 'Um die Sicherheit bei der Nutzung unserer Online Services zu erhöhen, setzen wir vermehrt auf eine zusätzliche Schutzmaßnahme: den SMS-Sicherheitscode. Teilen Sie uns daher am besten schon jetzt Ihre Mobilnummer dafür mit.',
        labels: {
          salutation: 'Anrede',
          firstname: 'Vorname oder Name',
          lastname: 'Nachname oder Zusatz',
          email: 'E-Mail-Adresse',
          emailHint: 'Kontakt im Rahmen der Online Services und Vertragsabwicklung',
          phone: 'Mobilnummer',
          code: '8-stelliger Code bisherige E-Mail-Adresse',
          codeNew: '8-stelliger Code neue E-Mail-Adresse',
          codePhone: '8-stelliger Code Mobilnummer'
        },
        validations: {
          salutation: {
            required: 'Bitte geben Sie Ihre Anrede ein.'
          },
          code: {
            required: 'Code ist erforderlich.'
          },
          email: {
            required: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
            email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
          },
          phone: {
            phoneNumberFormat: 'Bitte geben Sie eine gültige Mobilnummer.'
          }
        },
        messageContact: 'Ihre Kontaktdaten wurden erfolgreich geändert',
        messageEmail: 'Ihre E-Mail-Adresse wurde bestätigt',
        messagePhone: 'Ihre Mobilnummer wurde bestätigt'
      },
      contactHistory: {
        header: 'Online Kontakte',
        errors: {
          contactHistoryUnavailable: 'Leider stehen diese Daten im Moment nicht zur Verfügung.',
          emptyContactHistory: 'Leider stehen diese Daten im Moment nicht zur Verfügung.'
        }
      },
      businessPartner: {
        registeredText: "Ihre Registrierung ist erfolgreich abgeschlossen.",
        vkMissing: "Ihr Vertragskonto ist diesem Kundenkonto noch nicht zugeordnet.",
        header: 'Vertragskonto zuordnen',
        intro: 'Bitte benennen Sie uns die Vertragskontonummer eines zwischen Ihnen und Vattenfall bestehenden Vertrages und die dazugehörige Zählernummer, damit wir Ihre Registrierung mit Ihrer Geschäftspartnernummer verknüpfen können.<br /><br />Die Registrierung im Online Service gilt für alle Energielieferverträge, die zwischen Ihnen und Vattenfall unter derselben Geschäftspartnernummer bestehen oder zukünftig abgeschlossen werden, soweit Vattenfall die Abwicklung dieser Verträge über den Online Service technisch eingerichtet hat.',
        labels: {
          contractAccountNumber: 'Vertragskontonummer',
          meterNumber: 'Zählernummer',
          assignBtn: 'Vertragskonto Zuordnen',
          backBtn: 'Zurück',
          userProfileName: 'Benutzerprofil'
        },
        messages: {
          infoForAccountNo: 'Die Vertragskontonummer finden Sie auf unseren Schreiben.',
          generalInfo: 'Als Nutzer des Online Service erhalten Sie alle vertragsbezogenen Dokumente online. Über neue Post im Portal informieren wir Sie selbstverständlich per E-Mail.',
          errorMessage: 'Eine Registrierung ist mit diesem Vertragskonto nicht möglich.'
        },
        validations: {
          contractAccountNumber: {
            required: 'Bitte geben Sie Ihre Vertragskontonummer ein.',
            regex: 'Geben Sie eine 12-stellige Vertragskontonummer beginnend mit 83 ein.',
            serverError: 'Eine Registrierung ist mit diesem Vertragskonto nicht möglich.'
          },
          meterNumber: {
            required: 'Bitte füllen Sie dieses Feld aus.',
            regex: 'Bitte geben Sie 5 Ziffern ein.'
          }
        },
        thankYouPage: {
          vkAssigned: 'Ihr Vertrag wurde erfolgreich zugeordnet.',
          message: 'Folgende zusätzliche Vertragskonten können Sie künftig ebenfalls über den Vattenfall Online Service verwalten'
        }
      },
      spotInfo: {
        header: 'Preisalarm setzen',
        label: 'Preisalarm setzen (nur für Kunden der dynamischen Tarife)',
        hint: 'Wir informieren Sie automatisch per E-Mail, wenn der Strompreis zeitweise ungewöhnlich hoch oder niedrig ist.',
        subscribedMessage: 'Ihr Preisalarm wurde erfolgreich eingerichtet. Wir informieren Sie automatisch per E-Mail, sobald der Strompreis ungewöhnlich hoch oder niedrig ist.',
        unsubscribedMessage: 'Ihr Preisalarm wurde erfolgreich entfernt.'
      }
    },
    deleteBusinessPartner: {
      header: 'Geschäftspartner entfernen',
      text: 'Hier können Sie Verträge aus diesem Online-Account entfernen. Ordnen Sie diese danach unbedingt einem anderen oder neuen Account zu. Bei Erstellung eines <b>neuen Accounts</b> beachten Sie bitte, dass jede E-Mail-Adresse nur einmal vergeben werden darf. Klicken Sie in dem neuen Account im Menüpunkt <b>Vertrag & Umzug</b> ganz oben rechts auf „Bestehenden Vertrag hinzufügen“.<br /><br />Wenn Sie eine Neuzuordnung nicht möchten, <b>rufen Sie uns bitte umgehend an</b>, damit wir eine andere Lösung für Sie finden. Eine automatische Umstellung auf den Postversand erfolgt für die entfernten Verträge nicht.',
      submit: 'Geschäftspartner löschen',
      success: 'Geschäftspartner erfolgreich gelöscht.',
      unavailable: 'Der Prozess steht momentan nicht zur Verfügung.',
      back: 'Zur Startseite'
    },
    bankData: {
      banner: {
        title: 'Bezahldaten verwalten',
        subtitle: 'Den folgenden Daten können Sie Ihre aktuelle Zahlweise entnehmen. Haben Sie mehrere Verträge, so können Sie diese über \'Lieferstelle\', bzw. \'Vertrag\' auswählen. <br />Über die Schaltfläche \'Ändern\' können Sie nun Ihre Zahlungsart anpassen.'
      },
      header: {
        currentMethod: 'Aktuelle Zahlart',
        payoutOption: 'Auszahlungskonto Guthaben',
        edit: 'Zahlart ändern',
        yourBankDetails: 'Ihre Bankdaten',
        confirmationCode: 'Bestätigungscode eingeben'
      },
      entryPage: {
        directDebit: 'Per Bankeinzug',
        bankTransfer: 'Per Überweisung',
        bankTransferInfo: 'Sie überweisen fällige Zahlungen auf unser Bankkonto.',
        noPayout: 'Nicht hinterlegt',
        noPayoutInfo: 'Ihre Bankverbindung für Auszahlungen',
        payout: 'Bankverbindung hinterlegt',
      },
      labels: {
        directDebit: 'Bankeinzug',
        bankTransfer: 'Überweisung',
        iban: 'IBAN',
        bic: 'BIC',
        transferData: 'Überweisungsdaten',
        vfOwner: 'Empfänger',
        owner: 'Kontoinhaber (falls abweichend)',
        ownerOnly: 'Kontoinhaber',
        idNumber: 'Gläubiger-Identifikationsnummer',
        mandatNumber: 'Mandatsnummer',
        validFrom: 'Gültig ab',
        bankCode: 'Bankleitzahl',
        bankName: 'Bankname',
        accountNumber: 'Kontonummer',
        deleteIban: 'Auszahlungskonto löschen',
        changeBankData: 'Zahlungsinformationen speichern',
        bankDetails: 'Bankverbindung für fällige Zahlungen an Vattenfall',
        payoutAccount: 'Bankverbindung für Auszahlungen (optional)',
        consent: 'Ich ermächtige die Vattenfall Europe Sales GmbH, Zahlungen von meinem Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die von der Vattenfall Europe Sales GmbH auf mein Konto gezogenen Lastschriften einzulösen.',
        consentAdditionalInfo: '<strong>Hinweis:</strong> Ich kann innerhalb von acht Wochen, beginnend mit dem Datum der Belastung, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem Kreditinstitut vereinbarten Bedingungen.',
        vkNumber: 'Als Verwendungszweck nehmen Sie bitte Ihre Vertragskontonummer.',
        vkNumberInfo: 'Falls Sie die vollständige Vertragskontonummer suchen, finden Sie diese ausschließlich in Ihren Vertragsdokumenten, z. B. Ihrer Rechnung oder Vertragsbestätigung in Ihrem <a class="standard-link" href="/postfach">Postfach</a>.',
        confirmationCode: '8-stelliger Bestätigungscode',
        confirmationCodeHint: 'Tragen Sie bitte diesen 8-stelligen Code aus der E-Mail hier ein und bestätigen Ihre Eingabe mit dem gelben Button „Zahlungsinformationen speichern“.'
      },
      validations: {
        iban: {
          required: '<p>Ihre inländische IBAN besteht aus <strong>22 Zeichen.</strong> Beispiel: <strong>DE23 1000 0000 1234 5678 90.</strong></p>',
          pattern: '<p>Ihre inländische IBAN besteht aus <strong>22 Zeichen.</strong> Beispiel: <strong>DE23 1000 0000 1234 5678 90.</strong></p>'
        },
        bic: {
          required: 'Bitte füllen Sie dieses Feld aus.',
          pattern: 'Bitte geben Sie eine gültige BIC ein.'
        },
        consent: {
          checked: 'Sie müssen dem Lastschriftverfahren zustimmen.'
        },
        code: {
          required: 'Code ist erforderlich.',
          regex: 'Bitte geben Sie einen gültigen 8-stelligen Code ein.'
        }
      },
      vattenfallAccount: {
        info: 'Bitte überweisen Sie fällige Zahlungen auf unser Bankkonto. ',
        vfOwner: 'Vattenfall Europe Sales GmbH',
        iban: 'DE93 5005 0000 0090 0851 35',
        bankCode: '50050000',
        accountNumber: '90085135',
        bic: 'HELADEFF XXX'
      },
      errors: {
        blockedByRecentChange: 'Ihre Eingaben werden gerade verarbeitet.',
        badSolvency: '<h2>Nicht verfügbar</h2><br />Entweder haben Sie keine Berechtigung zur Erteilung einer Einzugsermächtigung oder es liegt eine technische Störung vor.<br /><br />Bitte entschuldigen Sie die Umstände. Vielen Dank.',
        general: 'Entweder haben Sie keine Berechtigung zur Erteilung einer Einzugsermächtigung oder es liegt eine technische Störung vor.'
      },
      sentPage: {
        headers: {
          iban: 'Vielen Dank für Ihre Eingabe. Wir haben Ihre Bankverbindung erhalten.',
          payout: 'Vielen Dank für Ihre Eingabe. Wir haben Ihre Bankverbindung für Auszahlungen erhalten.',
          deleteEZE: 'Vielen Dank für Ihre Eingabe. Wir haben Ihre Bankverbindung und das SEPA-Lastschriftmandat gelöscht.',
          deletedIban: 'Ihr Auszahlungskonto für Guthaben wurde erfolgreich gelöscht.'
        },
        thankYouMessage: 'In wenigen Minuten erhalten Sie eine Bestätigung per E-Mail.',
        codeSentEmail: 'Bitte bestätigen Sie die Eingabe Ihrer Bankdaten mit ihrem 8-stelligen Bestätigungscode, den Sie in wenigen Minuten per E-Mail von uns zugesendet bekommen.',
        codeSentPhone: 'Bitte bestätigen Sie die Eingabe Ihrer Bankdaten für die Auszahlung von Guthaben mit dem 8-stelligen Bestätigungscode, den Sie von uns per SMS auf Ihr Mobiltelefon gesendet bekommen.'
      }
    },
    contractAndDelivery: {
      banner: 'Vertrag & Umzug',
      billingAddress: 'Rechnungsadresse',
      postbox: 'Postfach',
      co: 'c/o',
      secondPartner: 'Zweiter Vertragspartner:',
      vkNumber: 'Vertragskonto-Nr.:',
      deleteGP: 'aus diesem Account entfernen',
      deleteGPHint: 'Hier können Sie Verträge aus diesem Online-Account entfernen. Ordnen Sie diese danach unbedingt einem anderen oder neuen Account zu. Bei Erstellung eines <b>neuen Accounts</b> beachten Sie bitte, dass jede E-Mail-Adresse nur einmal vergeben werden darf. Klicken Sie in dem neuen Account im Menüpunkt <b>Vertrag & Umzug</b> ganz oben rechts auf „Bestehenden Vertrag hinzufügen“.<br /><br />Wenn Sie eine Neuzuordnung nicht möchten, <b>rufen Sie uns bitte umgehend an</b>, damit wir eine andere Lösung für Sie finden. Eine automatische Umstellung auf den Postversand erfolgt für die entfernten Verträge nicht.',
      offlineCommunicationHint: 'Ihre Unterlagen erhalten Sie aktuell per Post. Stellen Sie jetzt auf Online-Kommunikation um und greifen Sie schneller und jederzeit digital auf Ihre Vertragsdokumente zu. So reduzieren wir gemeinsam Papierverbrauch und Postversand.',
      buttons: {
        addNewBP: 'Bestehenden Vertrag hinzufügen',
        changeButton: 'Ändern',
        moveInProcessButton: 'Weiteren Vertrag abschließen',
        reportRelocation: 'Umzug melden',
        retraction: 'Zum Widerruf',
        cancelContract: 'Vertrag kündigen',
        tariffDetails: 'Vertragsdetails',
        offlineCommunication: 'Auf Online Kommunikation umstellen'
      },
      contractTypes: {
        STROM: 'Strom',
        GAS: 'Gas',
        NONCOMM: 'Sonstige'
      }
    },
    retraction: {
      banner: 'Widerruf',
      message: 'Hiermit widerrufe ich folgende Vertragserklärung:',
      buttons: {
        cancel: 'Abbrechen',
        confirm: 'Jetzt widerrufen'
      },
      finished: {
        title: 'Vielen Dank, wir haben Ihren Widerruf erhalten!'
      }
    },
    postboxProcess: {
      banner: 'Postfach',
      showAllDocuments: 'Alle Dokumente anzeigen',
      showLessDocuments: 'Weniger Dokumente anzeigen',
      errorNoDocuments: 'Für dieses Vertragskonto stehen zur Zeit keine Dokumente zur Verfügung.',
      eInvoiceLink: 'Rechnung per E-Mail bestellen',
      table: {
        date: 'Datum',
        name: 'Name',
        documents: 'Dokument',
        showPdf: 'Anzeigen',
        downloadPdf: 'Download',
        correctInvoice: 'Rechnung korrigieren'
      }
    },
    changeInvoiceAddress: {
      banner: {
        title: 'Rechnungsadresse ändern',
        subtitle: 'Bitte teilen Sie uns mit, an welche Adresse wir zukünftig Ihre Rechnung versenden sollen.'
      },
      tooltips: {
        coName: 'Sollte Ihr Name nicht am Briefkasten stehen, können Sie hier den Namen auf dem Briefkasten eintragen.'
      },
      validations: {
        addressNotFound: 'Die Straße wurde unter der eingegebenen Postleitzahl nicht gefunden. Bitte überprüfen Sie Ihre Eingabe und bestätigen Sie mit "Speichern".',
        postalCode: {
          required: 'Bitte füllen Sie dieses Feld aus.',
          length: 'Bitte geben Sie 5 Ziffern ein.',
          postalCodeError: 'Diese Postleitzahl ist nicht bekannt oder wird von uns nicht beliefert. Bitte prüfen Sie Ihre Eingabe.',
          pattern: 'Diese Postleitzahl ist nicht bekannt oder wird von uns nicht beliefert. Bitte prüfen Sie Ihre Eingabe.'
        },
        street: {
          required: 'Bitte füllen Sie dieses Feld aus.',
          warningNotOnList: 'Die Straße wurde unter der eingegebenen Postleitzahl nicht gefunden. Bitte überprüfen Sie Ihre Eingabe und bestätigen Sie mit "Weiter".'
        },
        houseNumber: {
          required: 'Bitte füllen Sie dieses Feld aus.'
        },
        city: {
          required: 'Bitte füllen Sie dieses Feld aus.'
        }
      },
      responseDI: {
        errors: {
          differentInvoiceAddress: 'Das Ändern der Rechnungsadresse ist für diesen Vertrag nicht möglich.'
        }
      },
      sentPage: {
        message: 'Ihre Rechnungsadresse wurde erfolgreich geändert'
      }
    },
    communication: {
      contractTypes: {
        STROM: 'Strom',
        GAS: 'Gas',
        NONCOMM: 'Sonstige'
      },
      banner: {
        title: 'Online-Kommunikation'
      },
      thankYouPage: {
        header: 'Vielen Dank. Ihre Änderungen wurden gespeichert',
        desc: 'Ihre Kommunikation mit Vattenfall wurde auf elektronischen Versand umgestellt. Dadurch werden Sie Ihre Dokumente in Zukunft schneller erhalten und schonen zusätzlich die Umwelt.'
      },
      header: 'Verträge auf elektronischen Versand umstellen ',
      processIsNotAvailable: 'Dieser Prozess ist nicht verfügbar',
      businessPartner: 'Geschäftspartner auswählen',
      businessPartnerDisabled: 'Geschäftspartner',
      contractAccountNumber: 'Vertragskontonummer',
      way: 'Kommunikationsweg',
      intro: 'Hier haben Sie die Möglichkeit Ihre Kommunikation mit Vattenfall auf den elektronischen Versand umzustellen. Dadurch werden Sie Ihre Dokumente schneller erhalten und schonen zusätzlich die Umwelt.',
      agreedTxt: 'Elektronischer Versand',
      agreeLabel: 'Auf elektronischen Versand umstellen'
    },
    move: {
      date: '',
      currentProduct: 'Aktueller Tarif',
      finishButton: 'Zahlungspflichtig bestellen',
      banner: 'Umzug melden',
      optional: ' (optional)',
      required: '* Pflichtfeld ',
      noProductsText: "Aktuell können wir Ihnen keine Umzugstarife anbieten.",
      fullSummary: {
        header: 'Ihr Auftrag im Überblick',
        openDetails: 'Vertragsdaten anzeigen',
        closeDetails: 'Vertragsdaten schließen',
        print: 'Zusammenfassung drucken',
        movingData: 'Umzugsdaten',
        chooseTarif: 'Gewählter Tarif',
        paymentData: 'Bezahlung',
        title: 'Vielen Dank, wir haben den Auftrag zu Ihrem Umzug erhalten Ihr Auftrag wird nun geprüft.',
        nextStepsIntro: 'Wie geht es jetzt weiter?',
        nextStep1: 'Ihr Auftrag wird bearbeitet. Sie erhalten in Kürze eine Bestätigung zum Auftragseingang mit dem voraussichtlichen Termin zum Lieferbeginn. ',
        nextStep2: 'Zum Lieferbeginn erhalten Sie die Vertragsbestätigung, auch mit den Informationen zu Ihren Abschlägen.',
        nextStep3: 'Nach der Abmeldung Ihrer alten Lieferstelle zum Auszugstermin erhalten Sie eine Auszugsbestätigung und eine Schlussrechnung.',
        intro1: 'Vielen Dank!',
        intro2: 'Wir haben den Auftrag zu Ihrem Umzug erhalten!'
      },
      stepOne: {
        newAddress: 'Neue Lieferadresse',
        invoiceAddress: 'Rechnungsadresse',
        title: 'Umzugsdaten',
        currentAddress: 'Alte Lieferadresse',
        addressTitle: 'Neue Lieferstelle',
        introText: 'Geben Sie hier Ihre neue Adresse, die Zählernummer und Ihr Einzugsdatum an der neuen Lieferadresse ein. Falls Ihnen das Auszugsdatum der alten Lieferadresse schon bekannt ist, tragen Sie dieses unten ein. Den Auszugszählerstand melden Sie uns bitte erst nach der Schlüsselübergabe.',
        marketLocationsHint: 'Die Marktlokations-ID ist eine 11-stellige Nummer für die Lieferstelle und kann beim Netzbetreiber erfragt werden. Im Falle eines Lieferantenwechsels finden Sie diese auf der letzten Rechnung.',
        form: {
          city: 'Ort *',
          zipcode: 'Postleitzahl *',
          houseNumber: 'Hausnummer *',
          street: 'Straße *',
          meterNumber: 'Zählernummer',
          marketlocationsId: 'Marktlokations-ID',
          dateLabelMoveIn: 'Einzugsdatum',
          dateLabelMoveOut: 'Auszugsdatum',
          sameAsDeliveryAddress: 'Identisch mit neuer Lieferadresse',
          differentInvoiceAddress: 'Abweichend von neuer Lieferadresse',
          currentAddress: 'Aktuelle Lieferstelle',
          currentTariff: 'Aktueller Tarif',
          contractAccount: 'Vertragskonto'
        },
        validations: {
          zipcode: {
            required: 'Bitte füllen Sie dieses Feld aus.',
            length: 'Bitte geben Sie 5 Ziffern ein.',
            empty: 'Für die angegebene Postleitzahl wurden keine Orte gefunden.',
            blacklist: 'Die angegebene Postleitzahl gehört nicht zu unserem Liefergebiet.'
          },
          street: {
            required: 'Bitte füllen Sie dieses Feld aus.',
            incorrect: 'Die Straße wurde unter der eingegebenen Postleitzahl nicht gefunden.'
          },
          houseNumber: {
            required: 'Bitte füllen Sie dieses Feld aus.'
          },
          city: {
            required: 'Bitte füllen Sie dieses Feld aus.'
          },
          meterNumber: {
            required: 'Bitte füllen Sie dieses Feld aus.',
            regex: 'Die Zählernummer darf nur Zahlen, Buchstaben und die Zeichen "-", "_", "/" oder "\\" enthalten und kann max. 18 Zeichen lang sein.'
          },
          deliveryDate: {
            required: 'Bitte füllen Sie dieses Feld aus.'
          },
          moveInDate: {
            required: 'Bitte füllen Sie dieses Feld aus.',
            min: 'Bitte geben Sie ein Datum ab dem {value} ein.',
            max: 'Bitte geben Sie ein Datum bis einschließlich {value} ein.'
          },
          moveOutDate: {
            min: 'Bitte geben Sie ein Datum ab dem {value} ein.',
            max: 'Bitte geben Sie ein Datum bis einschließlich {value} ein.'
          },
          marketlocationsId: {
            required: 'Bitte füllen Sie dieses Feld aus.'
          },
          addressNotFound: 'Die Straße wurde unter der eingegebenen Postleitzahl nicht gefunden. Bitte überprüfen Sie Ihre Eingabe und bestätigen Sie mit "Weiter".'
        }
      },
      stepTwo: {
        addressTitle: 'Rechnungsadresse',
        title: 'Tarif wählen',
        bonusTitle: 'Bonus',
        bonusTitlePdf: 'Sonderangebote/Zusatzleistungen',
        footnotes: {
          showFootnotes: 'Fußnoten anzeigen',
          hideFootnotes: 'Fußnoten schließen'
        },
        summary: {
          newTarif: 'Neuer Tarif',
          yearlyPrice: 'Jahrespreis',
          productDetails: 'Produkt-/Preisdetails',
          productDetailsPdf: 'Aufschlüsselung der Preisbestandteile',
          basicPrice: 'Grundpreis',
          consumptionPrice: 'Verbrauchspreis'
        },
        moveProduct: {
          header: 'Ihren aktuellen Tarif nehmen Sie einfach zu Ihrer neuen Lieferadresse mit.',
          button: 'Tarif mitnehmen'
        },
        alternativeProduct: {
          header: 'Alternativ können Sie einen neuen Tarif wählen',
          button: 'Tarif wählen'
        },
        tariffDelivered: {
          link: 'Sie möchten Ihren derzeitigen Tarif nicht mitnehmen?',
          title: 'Sie möchten Ihren Tarif nicht mitnehmen?',
          info: 'Bitte rufen Sie uns an und wir beraten Sie individuell zu Ihrem Fall.',
          phoneNumber: '0800 1020 0404',
          hours: 'Mo. bis Fr. 8–16 Uhr (kostenfrei)'
        },
        labels: {
          consumptionPriceHT: 'Verbrauchspreise HT',
          consumptionPriceNT: 'Verbrauchspreise NT',
          meterFee: 'Entgelt Zähler',
          euroPerMonth: '€/Monat'
        },
        noTariffBox: {
          title: 'Bei Ihnen ist eine Tarifmitnahme nicht möglich.',
          titleWithCurrentProduct: 'Sie möchten Ihren Tarif nicht mitnehmen?',
          info: 'Wir helfen Ihnen persönlich weiter. Bitte rufen Sie uns an und wir beraten Sie individuell zu Ihrem Fall.',
          infoWithCurrentProduct: 'Bitte rufen Sie uns an und wir beraten Sie individuell zu Ihrem Fall. ',
          phoneNumber: '0800 1020 0404',
          hours: 'Mo. bis Fr. 8–16 Uhr (kostenfrei)'
        },
        noMoveTariff: {
          title: 'Bei Ihnen ist eine Tarifmitnahme nicht möglich. Bitte wählen Sie einen aktuellen Tarif für Ihre neue Adresse aus.'
        }
      },
      stepThree: {
        title: 'Bezahlung',
        userName: 'Name',
        paymentData: 'Bezahldaten',
        paymentType: 'Zahlungsart',
        directDebit: 'Bankeinzug',
        bankTransfer: 'Überweisung',
        iban: 'IBAN',
        bic: 'BIC',
        owner: 'Kontoinhaber',
        ownerEmpty: '(falls abweichend)'
      },
      stepFour: {
        title: 'Bestätigung',
        submitButton: 'Zahlungspflichtig bestellen',
        phoneHeader: 'Wir benötigen Ihre Telefonnummer',
        phone: 'Mobilfunknummer',
        phoneHint: 'Um die Sicherheit bei der Nutzung unserer Online Services zu erhöhen, setzen wir vermehrt auf eine zusätzliche Schutzmaßnahme: den SMS-Sicherheitscode. Teilen Sie uns daher am besten schon jetzt Ihre Mobilnummer dafür mit.',
        birthdateHeader: 'Geburtstag',
        birthdate: 'Geburtsdatum',
        companyIndustry: 'Branche',
        industryText: 'Da Sie einen Gewerbetarif ausgewählt haben, bitten wir Sie die dazugehörige Branche auszuwählen.',
        validation: {
          withdrawal: {
            checked: 'Bitte bestätigen Sie Ihr Einverständnis.'
          },
          companyIndustry: {
            required: 'Bitte füllen Sie dieses Feld aus.',
            notEmptyList: 'Die Liste der Branchen konnte nicht geladen werden. Bitte laden Sie die Seite neu.'
          },
          phone: {
            required: 'Bitte geben Sie eine gültige Telefonnummer ein.',
            phoneNumberFormat: 'Das Format der Telefonnummer ist ungültig.'
          },
          birthdate: {
            required: 'Bitte füllen Sie dieses Feld aus.'
          }
        }
      },
      summaryPage: {
        title: 'Zusammenfassung',
        introText: 'Bitte lesen Sie die Zusammenfassung der Daten zu Ihrem Umzug sorgfältig durch und bestätigen Sie anschließend mit "Zahlungspflichtig bestellen".',
        infoForMoveOut: 'Bitte beachten Sie, dass Ihr Auszugsdatum baldmöglichst nachgereicht werden muss. Solange uns kein Auszugsdatum vorliegt, kann ihr Umzug nicht abschließend bearbeitet werden. Sie können dies telefonisch innerhalb der Servicezeiten (Mo.-Fr. 8-16 Uhr) unter 0800 1020 0401 (kostenfrei) erledigen.',
        emptyMoveOutInfo: 'Noch offen'
      },
      thxPage: {
        expandButton: 'Vertragsdaten anzeigen',
        collapseButton: 'Vertragsdaten schließen',
        headline: 'Vielen Dank!',
        subHeadline: 'Wir haben den Auftrag zu Ihrem Umzug erhalten!',
        headList: 'Wie geht es jetzt weiter?',
        listItem1: 'Ihr Auftrag wird bearbeitet. Sie erhalten in Kürze eine Bestätigung zum Auftragseingang mit dem voraussichtlichen Termin zum Lieferbeginn. ',
        listItem2: 'Zum Lieferbeginn erhalten Sie die Vertragsbestätigung, auch mit den Informationen zu Ihren Abschlägen.',
        listItem3: 'Nach der Abmeldung Ihrer alten Lieferstelle zum Auszugstermin erhalten Sie eine Auszugsbestätigung und eine Schlussrechnung.',
        meterReadingInfo: 'Optional können Sie jetzt hier Ihren Auszugszählerstand übermitteln. Natürlich ist es ebenso möglich, dies zu einem späteren Zeitpunkt in Ihrem Online-Account zu erledigen.',
        meterReadingLink: 'Auszugszählerstand übermitteln'
      }
    },
    passwordForgotten: {
      banner: {
        title: 'Passwort zurücksetzen',
        subtitle: 'Nach erfolgreicher Identifizierung schicken wir Ihnen eine E-Mail, mit der Sie Ihr Passwort ändern und Ihren Zugang entsperren können.'
      },
      header: 'E-Mail  mit Bestätigungscode anfordern',
      message: 'Um Ihr Passwort zurückzusetzen, tragen Sie hier bitte Ihren Benutzernamen oder ihre E-Mail-Adresse ein und klicken auf den gelben Button „E-Mail anfordern“.',
      changePass: 'Bestätigungscode eingeben',
      enterCode: 'Tragen Sie bitte diesen 8-stelligen Code aus der E-Mail und ein neues Passwort hier ein und bestätigen Ihre Eingabe mit dem gelben Button  „senden“.',
      mailSent: 'Sie erhalten in wenigen Minuten eine E-Mail mit ihrem 8-stelligen Bestätigungscode.',
      buttons: {
        send: 'E-Mail anfordern'
      },
      tooltips: {
        identifier: 'Falls Sie dieselbe E-Mail-Adresse in mehreren Vattenfall Online-Accounts hinterlegt haben, verwenden Sie bitte den Benutzernamen zur Identifizierung des betroffenen Accounts.',
        code: 'Sie erhalten in den nächsten Minuten Ihren 8-stelligen Bestätigungscode per E-Mail, den Sie hier in dieses Feld eintragen müssen.'
      },
      labels: {
        identifier: 'Benutzername oder E-Mail',
        code: '8-stelliger Bestätigungscode',
        passwordNew: 'Neues Passwort'
      },
      validations: {
        identifier: {
          required: 'Bitte füllen Sie dieses Feld aus.',
          testuser: 'Leider können wir zu Ihrer Eingabe kein Konto finden. Bitte prüfen Sie Ihre Daten und versuchen Sie es erneut.'
        },
        code: {
          required: 'Code ist erforderlich.'
        },
        passwordNew: {
          required: 'Bitte wählen Sie ein Passwort.',
          valid: 'Das Passwort muss zwischen 10 und 35 Zeichen lang sein.'
        }
      },
      sentPage: {
        header: 'Ihr Passwort wurde erfolgreich geändert.',
        message: 'Wir haben Ihnen zusätzlich eine E-Mail geschickt, mit der wir Ihnen die erfolgreiche Änderung Ihres Passworts bestätigen.'
      }
    },
    passwordChange: {
      banner: {
        title: 'Passwort ändern',
        subtitle: 'Für einen besseren Schutz empfehlen wir eine Kombination aus Zahlen, Groß- und Kleinbuchstaben sowie Sonderzeichen.'
      },
      header: 'Bitte geben Sie Ihr neues Passwort ein',
      labels: {
        newPassword: 'Neues Passwort',
        repeatPassword: 'Neues Passwort wiederholen'
      },
      validations: {
        newPassword: {
          required: 'Bitte wählen Sie ein Passwort.',
          valid: 'Das Passwort muss zwischen 10 und 35 Zeichen lang sein.'
        },
        repeatPassword: {
          required: 'Bitte wiederholen Sie das gewählte Passwort.',
          inequal: 'Die eingegebenen Passwörter sind nicht identisch.'
        }
      },
      disabledPage: {
        header: 'Passwortänderung nicht möglich',
        resetLinkText: 'Passwort zur&uuml;cksetzen',
        helpLinkText: 'Hilfe &amp; Kontakt',
        message: `<p>Aufgrund des folgenden Fehlers kann Ihr Passwort leider nicht zur&uuml;ckgesetzt werden:<br />
        <br />
        <strong>{reason}</strong><br />
        <br />
        Wenn Sie Ihr Passwort erneut zur&uuml;cksetzen m&ouml;chten, nutzen Sie bitte noch einmal die Funktion {resetLink}. <br /><br />
        Haben Sie Fragen oder suchen einen Ansprechpartner, dann besuchen Sie bitte {helpLink}.</p>`
      },
      sentPage: {
        header: 'Ihr Passwort wurde erfolgreich geändert.',
        userProfileName: 'Benutzerprofil'
      }
    },
    deregister: {
      banner: {
        title: 'Benutzerprofil löschen',
        subtitle: 'Bitte beachten Sie, dass dieser Schritt nicht rückgängig gemacht werden kann. Falls Sie den Kundenservice Online später wieder nutzen möchten, müssen Sie sich neu registrieren.'
      },
      message: 'Möchten Sie sich wirklich deregistrieren? Eine Nutzung des Vattenfall Online Service ist anschließend nicht mehr möglich.',
      button: 'Benutzerprofil endgültig löschen',
      username: 'Benutzerprofil',
      sentPage: {
        banner: 'Benutzerprofil gelöscht',
        header: 'Bestätigung',
        linkText: 'hier',
        message: 'Sie wurden erfolgreich deregistriert.<br /><br />Um sich über aktuelle Neuigkeiten von Vattenfall zu informieren, klicken Sie bitte {link}.'
      }
    },
    passwordValidationIndicator: {
      before: 'Das Passwort muss folgende Kriterien erfüllen:',
      isLongEnough: '10 Zeichen',
      hasBigAndSmallChars: 'Groß- und Kleinbuchstaben',
      hasNumbers: 'Eine Zahl',
      maximumLength: 'Maximal 35 Zeichen'
    },
    loadProfile: {
      contractTypes: {
        ELECTRICITY: 'Strom',
        GAS: 'Gas'
      },
      send: 'Neu berechnen',
      noData: 'Für den ausgewählten Zeitraum sind keine Daten verfügbar.',
      thisWeek: 'Daten aus dieser Woche anzeigen',
      thisMonth: 'Daten aus diesem Monat anzeigen',
      downloadText: 'Die gemessenen Einzelwerte können Sie sich auch als Excel-Datei über den folgenden Link herunterladen: ',
      labelExcel: 'Lastgangdaten in Tabellenform',
      banner: 'Lastgang',
      date: 'Datum',
      fromDate: 'Von Datum',
      toDate: 'Bis Datum',
      title: 'Lastgänge',
      deliveryAddress: 'Lieferstelle',
      contract: 'Vertrag',
      deliveryPoint: 'Marktlokationsnummer',
      sendButton: 'Neu berechnen',
      labels: {
        day: 'Tag',
        thisWeek: 'Diese Woche',
        thisMonth: 'Dieser Monat',
        timePeriod: 'Festgelegter Zeitraum'
      },
      validationsDate: {
        required: 'Bitte geben Sie das Datum im Format TT.MM.JJJJ ein.',
        beforeMinimum: 'Bitte geben Sie ein Datum bis einschließlich {minDateText} ein.',
        afterMaximum: 'Bitte geben Sie ein Datum ab dem {maxDateText} ein.'
      }
    },
    excelFile: {
      title: 'Treten in der Leistungsspalte leere Zellen auf, so ist für diesen Zeitpunkt leider kein Meßwert verfügbar.',
      sheetName: 'Lastgangtabelle',
      workBookName: 'Messwerte_',
      firstColumnHeader: 'Datum/Zeit',
      secondColumnHeader: 'Leistung/kW',
      labels: {
        pointOfDeliveryDesignation: 'MarktlokationsId',
        loadType: 'Lastgangtyp',
        unitOfMeasurement: 'Maßeinheit',
        amountOfMeasurementData: 'Meßperiodenanzahl',
        downloadTime: 'Downloadzeitpunkt'
      }
    },
    installmentPlan: {
      banner: 'Ratenplan vereinbaren',
      subtitle: 'Sie können einen Ratenplan in einem vorgegebenen Rahmen festlegen',
      title: 'Ratenplan zur Begleichung der offenen Forderung festlegen',
      totalValueText: 'Unsere offene Gesamtforderung beträgt:',
      totalValueWithoutDepositText: 'Unsere offene Gesamtforderung ohne Abschläge beträgt:',
      listInformation: {
        li1: 'Die einmaligen Bearbeitungskosten betragen {fee}',
        li2: 'Nachdem Sie Startdatum und Ratenhöhe bestimmt haben, können Sie unter “Vorschau anzeigen” Ihren möglichen Ratenplan vorab sehen',
        active1: 'Ihr Ratenplan kann maximal bis zur nächsten Jahresabrechnung abgeschlossen werden',
        active2: 'Ihr monatlicher Zahlbetrag setzt sich jeweils aus Ihrer Rate und Ihrem monatlichen Abschlag zusammen',
        inactive1: 'Ihr Ratenplan kann maximal für 12 Monate abgeschlossen werden',
        infoIcon: 'Ein für Sie passender Ratenplan kann immer nur bis zur nächsten Jahresverbrauchsabrechnung vereinbart werden, da sich danach wieder eine völlig neue Berechnungsgrundlage ergibt. Erst mit der Jahresverbrauchsabrechnung können wir ermitteln, ob Ihr tatsächlicher Verbrauch zu den von Ihnen gezahlten Abschlägen passt. Da sich dabei entweder ein Guthaben oder eine Forderung ergibt, kann das nicht schon vorher im Ratenplan berücksichtigt werden.'
      },
      datepickerLabel: 'Wann soll die erste Rate starten?',
      amountOfInstallments: 'Ratenanzahl:',
      payment: 'Wie hoch sollen die Raten sein?',
      buttonPreview: 'Vorschau anzeigen',
      buttonCancel: 'Abbrechen',
      goBackToForm: 'Ratenplan ändern',
      sendButton: 'Ratenplan kostenpflichtig abschließen',
      sendButtonWithoutCosts: 'Ratenplan abschließen',
      previewHeader: 'Vorschau Ihres Ratenplans',
      previewIntro: 'Im von Ihnen gewählten Ratenplan sind folgende Forderungen enthalten:',
      previewIntroWithoutDeposit: 'In Ihrem gewählten Ratenplan sind diese offenen Forderungen ohne Abschläge enthalten:',
      previewListInformation: {
        li1: 'Unsere Forderung in Höhe von {amount}',
        li2: 'Die Bearbeitungskosten für die Erstellung Ihres Ratenplans von {fee}',
        active1: 'Ihre weiterhin monatlich anfallenden <strong>Abschlagszahlungen von {openPartPayment}</strong> während der gesamten Laufzeit Ihres Ratenplans'
      },
      previewIntro2: 'Ihre monatlichen Abschläge sind nicht im Ratenplan enthalten und müssen separat beglichen werden. Hier sind Ihre Zahlungstermine für Ihre Raten:',
      previewIntro3: 'Hier sind Ihre Zahlungstermine für Ihre Raten:',
      tableHeaderLp: 'Rate',
      tableHeaderDate: 'Fälligkeitsdatum',
      tableHeaderValue: 'Zahlbetrag',
      firstRateInfoActive: 'Ihr Zahlbetrag setzt sich jeweils aus Ihrer gewählten Rate und Ihrem monatlichen Abschlag zusammen.<br />Da Sie nur einen glatten Eurobetrag als Rate wählen können, entsteht meist ein Differenzbetrag zwischen der Summe aller Raten und der Gesamtforderung.<br /> Dieser Differenzbetrag und die Bearbeitungskosten werden dem ersten Zahlbetrag zugeschlagen.',
      firstRateInfoInactive: 'Da Sie nur einen glatten Eurobetrag als Rate wählen können, entsteht meist ein Differenzbetrag zwischen der Summe aller Raten und der Gesamtforderung.<br />Dieser Differenzbetrag und die Bearbeitungskosten werden dem ersten Zahlbetrag zugeschlagen.',
      firstRateInfoDepositeNotIncluded: 'Da Sie Ihre monatliche Rate nur als runden Betrag wählen können, kann sich ein geringer Differenzbetrag ergeben, der in der ersten Rate enthalten ist. Dieser Differenzbetrag und die Bearbeitungskosten sind in der ersten Rate enthalten.',
      infoBoxTitle: 'Beachten Sie bitte:',
      infoBoxText: 'Diese Ratenzahlungsvereinbarung wird sofort und ohne Ankündigung ungültig, sobald eine Rate nicht pünktlich oder nicht in voller Höhe bezahlt wird Die Gesamtforderung ist dann ohne Aufforderung sofort zu zahlen.',
      depositNotIncluded: '<strong>Ihre monatlichen Abschläge sind nicht im Ratenplan enthalten und müssen separat beglichen werden.</strong><br />Beachten Sie bitte hierzu Ihre Zahlungstermine.',
      thxPage: {
        header: 'Sie haben Ihren Ratenplan erfolgreich erstellt',
        subheader: 'Wie geht es jetzt weiter?',
        installmentsPlan: 'Ihr Ratenplan',
        li1: 'Sie erhalten in den kommenden Tagen die Bestätigung der Ratenvereinbarung mit allen Informationen zu Ihrem Ratenplan. Diese finden Sie in Ihrem digitalen Postfach.',
        li3: 'Höhe und Fälligkeit der nächsten Raten finden Sie unten in der Tabelle oder direkt im Schreiben',
        directDebit: {
          li2: 'Ihre <strong>1. Rate von {amount}</strong> buchen wir <strong>zum {date}</strong> von dem Konto mit der IBAN <strong>{iban}</strong> ab.',
          bankDataHeader: 'Bezahldaten für SEPA-Abbuchung'
        },
        transferPayer: {
          li2: 'Überweisen Sie bitte die <strong>1. Rate von {amount}</strong> rechtzeitig auf das unten genannte Konto, damit der Betrag <strong>bis zum {date}</strong> bei uns eingegangen ist.',
          bankDataHeader: 'Bezahldaten für Ihre Überweisung',
          switchToDirectDebit: {
            header: 'SEPA-Lastschriftmandat',
            text: 'Wenn Sie am SEPA-Verfahren teilnehmen, brauchen Sie nicht mehr selbst an Zahlungstermine zu denken. Ihre gesamten Zahlungen an Vattenfall gehen sicher und pünktlich bei uns ein.',
            button: 'Sepa-Lastschriftmandat erteilen'
          }
        },
        bankData: {
          directDebit: 'Bankeinzug',
          paymentBy: 'Art der Bezahlung',
          accountOwner: 'Kontoinhaber',
          creditInstitute: 'Kreditinstitut',
          receiver: 'Empfänger',
          iban: 'IBAN',
          bic: 'BIC',
          creditIdentificatorNumber: 'Gläubiger Identifikationsnummer'
        },
        vattenfallAccount: {
          bankTransfer: 'Überweisung',
          bank: 'Frankfurter Volksbank',
          receiver: 'Vattenfall Europe Sales GmbH',
          accountLabel: 'Kontonummer',
          bankAaccounNumber: '9008513590085135',
          bankCodeLabel: 'Bankleitzahl',
          info: 'Bitte überweisen Sie fällige Zahlungen auf unser Bankkonto. ',
          iban: 'DE93 5005 0000 0090 0851 35',
          bankCode: '50050000',
          accountNumber: '90085135',
          bic: 'HELADEFFXXX',
          usageLabel: 'Verwendungszweck'
        }
      }
    },
    moveIn: {
      header: 'Weiteren Vertrag abschließen',
      select: 'Auswählen',
      next: 'Weiter',
      previous: 'Zurück',
      back: 'Zur Tarifauswahl',
      yourTariff: 'Ihr Tarif',
      tariff: {
        consumptionAnnual1: 'bei ',
        consumptionAnnual2: ' kWh<br />Jahresverbrauch',
        priceAnnual: 'Jahrespreis',
        priceOnce: 'Einmalpreis',
        priceBase: 'Grundpreis',
        meterFee: 'Entgelt Zähler',
        meterFeeInfo: 'Das Entgelt Zähler gilt für eine konventionelle Messeinrichtung. Je nach eingebauter Zählerart ergeben sich unterschiedliche Kosten. Weitere Informationen finden Sie',
        priceConsumptionSingle: 'Verbrauchspreis',
        priceConsumptionHigh: 'Verbrauchspreise HT',
        priceConsumptionNormal: 'Verbrauchspreise NT',
        euro: '€',
        here: 'hier.',
        month: '/Monat',
        euroPerMonth: '€/Monat',
        centPerKwh: 'Cent/kWh',
        contractDuration: 'Mindestvertragslaufzeit',
        contractExtension: 'Vertragsverlängerung',
        onlineTariff: 'Online-Tarif',
        priceGuarantee: 'Preisgarantie',
        bonus: 'Bonus',
        resignationPeriod: 'Kündigungsfrist',
        validations: {
          wallboxAgreement: {
            checked: ''
          }
        }
      },
      step0: {
        header: 'Ihr Vattenfall-Experte empfiehlt:',
        buttons: {
          original: 'Tarif beibehalten',
          upsell: 'Jetzt Tarif optimieren'
        },
        selected: {
          original: 'Keine Optimierung gewünscht',
          upsell: 'Ihr Tarif wurde optimiert'
        }
      },
      step1: {
        header: 'Persönliche Daten',
        salutation: 'Anrede',
        firstname: 'Vorname',
        lastname: 'Nachname',
        firstPerson: 'Vertragspartner',
        secondPerson: 'Zweiter Vertragspartner',
        industry: 'Angaben zur Branche',
        email: 'E-Mail-Adresse',
        emailHint: 'Die Vattenfall Europe Sales GmbH nutzt Ihre E-Mail-Adresse, um Sie im Rahmen unserer Online-Services, zur Vertragsabwicklung und zur Information über eigene, ähnliche Energieprodukte zu kontaktieren. Dem können Sie jederzeit per E-Mail an werbewiderspruch@vattenfall.de widersprechen.',
        phone: 'Telefonnummer',
        phoneHint: 'Geben Sie hier Ihre Festnetz- oder Mobilnummer an, damit wir etwaige Rückfragen mit Ihnen schneller klären können. Bitte geben Sie nur Ziffern ein, z.B. 0171 1234567.',
        mobilephone: 'Mobilfunknummer',
        mobilephoneHint: 'Um die Sicherheit bei der Nutzung unserer Online Services zu erhöhen, setzen wir vermehrt auf eine zusätzliche Schutzmaßnahme: den SMS-Sicherheitscode.<br />Teilen Sie uns daher am besten schon jetzt Ihre Mobilnummer dafür mit.',
        companyName1: 'Firmierung',
        companyName2: 'Firmierung Zusatz',
        companyNumber: 'Handelsregisternr.',
        companyCourt: 'Handelsgericht',
        companyIndustry: 'Branche',
        birthDate: 'Geburtstag',
        zipcode : 'Postleitzahl',
        city: 'Ort',
        district: 'Ortsteil',
        street: 'Straße',
        houseNumber: 'Nr.',
        inCareOf: 'c/o',
        inCareOfHint: 'Sollte Ihr Name nicht am Briefkasten stehen, können Sie hier den Namen auf dem Briefkasten eintragen.',
        deliveryAddress: 'Lieferanschrift',
        address: 'Anschrift',
        billingAddress: 'Rechnungsadresse',
        differentBillingAddress: 'Abweichende Rechnungsadresse',
        houseNumberLeadingDigit: 'Hausnummer muss mit einer Ziffer beginnen.',
        addressNotFound: 'Die Straße wurde unter der eingegebenen Postleitzahl nicht gefunden. Bitte überprüfen Sie Ihre Eingabe und bestätigen Sie mit "Weiter".',
        validations: {
          salutation: {
            required: 'Bitte geben Sie Ihre Anrede ein.'
          },
          birthDate: {
            required: 'Bitte geben Sie Ihren Geburtstag ein.',
            max: 'Bitte geben Sie ein Datum bis einschließlich {value} ein.'
          },
          email: {
            email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
            required: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
          },
          phone: {
            required: 'Bitte geben Sie eine gültige Telefonnummer ein.',
            phoneNumberFormat: 'Das Format der Telefonnummer ist ungültig.'
          },
          companyName: {
            regex: 'Geben Sie bitte eine gültige Firmierung mit maximal 35 Zeichen ein.'
          },
          companyNumber: {
            regex: 'Bitte geben Sie eine gültige Handelsregisternr. ein. Diese beginnt mit HRA, HRB oder VR.'
          },
          companyCourt: {
            selected: 'Bitte geben Sie ein gültiges Handelsgericht ein.'
          },
          companyIndustry: {
            required: 'Bitte füllen Sie dieses Feld aus.',
            notEmptyList: 'Die Liste der Branchen konnte nicht geladen werden. Bitte laden Sie die Seite neu.'
          }
        }
      },
      step2: {
        header: 'Angaben zur Belieferung',
        reason: 'Bestellgrund',
        reasonChange: 'Lieferantenwechsel',
        reasonChangeDescriptionPrivate: 'Ich bleibe in meiner Wohnung und möchte von meinem bisherigen Lieferanten zu Vattenfall wechseln.',
        reasonChangeDescriptionCompany: 'Ich bleibe am selben Standort und möchte von meinem bisherigen Lieferanten zu Vattenfall wechseln.',
        reasonMove: 'Umzug / Einzug',
        reasonMoveDescriptionPrivate: 'Ich ziehe in eine neue Wohnung ein oder bin bereits umgezogen und möchte dort von Vattenfall versorgt werden.',
        reasonMoveDescriptionCompany: 'Ich ziehe an einen neuen Standort oder bin bereits umgezogen und möchte dort von Vattenfall versorgt werden.',
        reasonSelect: 'Wählen',
        dateNext: 'Nächstmöglicher Termin',
        dateNextHint: 'Die Auswahl „Nächstmöglicher Termin“ hängt von der Vertragslaufzeit und der Kündigungsfrist Ihres derzeitigen Energielieferanten ab. Bei dieser Option werden wir unter den oben genannten Abhängigkeiten den frühestmöglichen Starttermin für Ihre Belieferung anstreben. Falls Sie einen späteren Termin bevorzugen, wählen Sie die Option „Wunschtermin“.',
        dateCustom: 'Wunschtermin',
        meterNumber: 'Zählernummer',
        meterNumberHint: 'Ihre Zählernummer finden Sie auf der Auftragsbestätigung oder Ableseaufforderung Ihrer letzten Energierechnung oder, falls Sie neu eingezogen sind, auf Ihrem Übergabeprotokoll. Natürlich finden Sie die Zählernummer auch immer auf Ihrem Zähler, häufig in der Nähe des Barcodes.',
        meterReading: 'Zählerstand ohne Nachkommastelle',
        meterReadingHint: 'Tragen Sie hier Ihren Zählerstand ohne Nachkommastellen ein. Bitte prüfen Sie Ihre Eingabe, bevor Sie Ihren Zählerstand an uns schicken.',
        meterReadingFuture: 'Am Tag des Liefergebinns einzutragen.',
        marketlocationsId: 'Marktlokations-ID',
        previousSupplier: 'Bisheriger Lieferant',
        customerNumber: 'Kundennummer',
        customerNumberHint: 'Ihre Kundennummer bei Ihrem bisherigen Energielieferanten finden Sie in Schreiben zu Vertragsangelegenheiten und Rechnungen von diesem.',
        optional: 'Optional',
        previousSupplierQuestion: 'Haben Sie beim bisherigen Lieferanten bereits gekündigt?',
        yes: 'Ja',
        no: 'Nein',
        date: 'Datum',
        quitDate: 'Kündigungsdatum',
        moveAgreementPrivate: 'Erstbezug nach Neubau: Ich ziehe in einen Neubau oder in eine sanierte Wohnung. Beim Neubau oder bei der Sanierung wurden neue Strom- bzw. Gaszähler installiert.',
        moveAgreementCompany: 'Erstbezug nach Neubau: Ich ziehe in einen Neubau oder an einen sanierten Standort. Beim Neubau oder bei der Sanierung wurden neue Strom- bzw. Gaszähler installiert.',
        moveAgreementHint: 'Wählen Sie diese Option, wenn Sie in einem neu gebauten Haus oder nach einer Renovierung mit neu gesetztem Zähler von Vattenfall beliefert werden möchten. Beachten Sie bitte, dass nicht schon Ihr Vermieter, Verwalter oder Verkäufer auf dem Zähler angemeldet ist. Falls doch, wählen Sie bitte „Einzug / Umzug“.',
        deliveryStart: 'Lieferbeginn',
        validations: {
          dateCustom: {
            required: 'Bitte geben Sie hier Ihren Wunschtermin ein.',
            min: 'Bitte geben Sie ein Datum ab dem {value} ein.',
            max: 'Bitte geben Sie ein Datum bis einschließlich {value} ein.',
          },
          meterNumber: {
            required: 'Bitte geben Sie hier Ihre Zählernummer ein.',
            meterNumberFormat: 'Die Zählernummer darf keine Leerzeichen oder Fragezeichen enthalten.'
          },
          meterReading: {
            notZero: 'Bitte geben Sie einen kWh-Wert größer als 0 ein.'
          },
          marketlocationsId: {
            required: 'Bitte füllen Sie dieses Feld aus.'
          },
          previousSupplier: {
            required: 'Bitte geben Sie hier Ihren bisherigen Lieferanten ein.',
            listed: 'Der eingegebene Lieferant ist uns leider nicht bekannt. Bitte korrigieren Sie Ihre Eingabe.'
          },
          previousSupplierQuitDate: {
            required: 'Bitte geben Sie hier ein Datum ein.',
            min: 'Bitte geben Sie ein Datum ab dem {value} ein.',
            max: 'Bitte geben Sie ein Datum bis einschließlich {value} ein.',
          }
        }
      },
      step3: {
        header: 'Zahlungsdaten',
        payment: 'Art der Bezahlung',
        paymentSepa: 'SEPA-Lastschriftmandat',
        paymentTransfer: 'Überweisung',
        paymentTransferInfo: 'Den monatlich zu zahlenden Abschlagsbetrag sowie die Überweisungsdaten bekommen Sie rechtzeitig vor dem Beginn der Belieferung.',
        iban: 'IBAN',
        ibanRequired: 'Bitte tragen Sie hier Ihre Zahlungsdaten für Ihr SEPA-Lastschriftmandat ein.',
        ibanRecommended: 'Wir empfehlen Ihnen die Bezahlung per SEPA-Lastschriftmandat, da Sie sich in diesem Fall um nichts kümmern müssen. Wenn Sie Ihre Abschlagszahlungen monatlich selbst überweisen möchten, klicken Sie einfach auf weiter.',
        ibanSafety: 'Ihre Bezahldaten werden verschlüsselt über einen Sicherheitsserver übertragen.',
        bic: 'BIC',
        owner: 'Kontoinhaber',
        ownerEmpty: '(falls abweichend)',
        ibanAgreement: 'Ich ermächtige die Vattenfall Europe Sales GmbH Zahlungen von meinem Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die von der Vattenfall Europe Sales GmbH auf mein Konto gezogenen Lastschriften einzulösen.<br /><b>Hinweis:</b> Ich kann innerhalb von acht Wochen, beginnend mit dem Datum der Belastung, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem Kreditinstitut vereinbarten Bedingungen.',
        validations: {
          iban: {
            regex: 'Bitte geben Sie eine gültige IBAN ein.'
          },
          bic: {
            regex: 'Bitte geben Sie eine gültige BIC ein.'
          },
          ibanAgreement: {
            checked: 'Sie müssen dem Lastschriftverfahren zustimmen.'
          }
        }
      },
      step4: {
        header: 'Bestellung',
        submit: 'Zahlungspflichtig bestellen',
        cancel: 'Bestellung abbrechen',
        validations: {
          termsAndConditions: {
            checked: ''
          },
          cancelPolicy: {
            checked: ''
          },
          customerConfirmation: {
            checked: 'Bitte bestätigen Sie Ihr Einverständnis.'
          }
        }
      },
      thankYouPage: {
        header: 'Vielen Dank, wir haben Ihre Bestellung erhalten',
        order: 'Ihr Auftrag wird nun geprüft',
        nextSteps: 'Was sind die nächsten Schritte?',
        pointOne: 'Ihr Auftrag wird nun von uns bearbeitet. In Kürze erhalten Sie dazu eine Auftragseingangsbestätigung per E-Mail.',
        pointTwo: 'Sofern uns der vorgemerkte Lieferbeginn vom Netzbetreiber zugesagt wird, erhalten Sie kurz vor Lieferbeginn Ihre Vertragsbestätigung – auch mit den Informationen zu Ihren Abschlägen.',
        expandButton: 'Vertragsdaten anzeigen',
        collapseButton: 'Vertragsdaten schließen',
        backButton: 'Zur Startseite'
      },
      footnotes: {
        showFootnotes: 'Fußnoten anzeigen',
        hideFootnotes: 'Fußnoten schließen',
        footnoteEmailPhone: 'Zu diesem Zwecke gestatte ich der Vattenfall Europe Sales GmbH, die von mir erhobenen personenbezogenen Daten (Rufnummer, E-Mail-Adresse) zu verarbeiten. Meine Einwilligung in die Nutzung meiner Daten zu Werbezwecken ist für die Vertragserfüllung nicht erforderlich und gilt bis auf Widerruf, den ich jederzeit mit Wirkung für die Zukunft im Online Service auf <a class="standard-link" href="https://www.vattenfall.de">www.vattenfall.de</a> oder per Telefon unter 0800 9925 000 erklären kann. Überschneidungen mit bereits versandten Werbemitteilungen sind möglich. Im Falle des Widerrufs entstehen keine anderen Kosten als die Übermittlungskosten nach den Basistarifen.'
      }
    },
    moveInConsumption: {
      header: 'Weiteren Vertrag abschließen',
      title: 'Jetzt günstigen Tarif finden',
      private: 'Privatkunden',
      company: 'Gewerbekunden',
      electricity: 'Strom',
      gas: 'Gas',
      submit: 'Jetzt berechnen',
      select: 'Auswählen',
      sector: 'Wählen',
      zipcode: 'Ihre Postleitzahl',
      people: 'Personen im Haushalt',
      consumption: 'Verbrauch (kWh/Jahr)',
      orConsumption: 'ODER Verbrauch (kWh/Jahr)',
      street: 'Straße',
      houseNumber: 'Hausnummer',
      validations: {
        consumption: {
          required: 'Bitte füllen Sie dieses Feld aus.',
          withinConstraints: 'Bitte geben Sie einen Vorjahresverbrauch zwischen 100 kWh und {max} kWh an.'
        },
        street: {
          required: 'Bitte füllen Sie dieses Feld aus.',
          incorrect: 'Die Straße wurde unter der eingegebenen Postleitzahl nicht gefunden.'
        },
        houseNumber: {
          required: 'Bitte füllen Sie dieses Feld aus.'
        },
        city: {
          required: 'Bitte füllen Sie dieses Feld aus.'
        }
      }
    },
    tariffDetails: {
      banner: 'Tarifdetails',
      basePrice: 'Grundpreis',
      consumptionPrice: 'Verbrauchspreis',
      priceGuarantee: 'Preisgarantie',
      minimumContractLength: 'Mindestvertragslaufzeit',
      resignationPeriod: 'Kündigungsfrist',
      contractExtension: 'Vertragsverlängerung',
      cancelDate: 'Nächstmöglicher Kündigungstermin',
      priceGuaranteeDeadline: 'Preisgarantie',
      until: 'bis ',
      meterFee: {
        header: 'Entgelt Zähler',
        type: 'Zählertyp',
        monthlyCost: 'Monatskosten',
        yearlyCost: 'Jahreskosten',
        netto: 'Netto',
        brutto: 'Brutto'
      },
      dynamicTariff: {
        spotprice: 'Spotmarktpreis',
        spotvalue: 'dynamisch in Cent/kWh',
        transitionalprice: 'Übergangspreis',
        transitionalvalue: 'Ø-Börsenpreis in Cent/kWh',
        maxLimit: 'Höchstpreislimit',
        minLimit: 'Tiefstpreislimit',
        info: 'für den Börsenpreis je Viertelstunde'
      }
    },
    authorizedPerson: {
      personsHeader: 'Vollmachten',
      banner: 'Vollmacht',
      header: 'Vollmacht pro Vertrag erteilen',
      avaButton: 'Vollmacht verwalten',
      tileSecondHeader: 'Wir wollen Sie vor Datenmissbrauch schützen!',
      tileText: 'Erteilen Sie eine Vollmacht, wenn jemand anderes für Sie vertragsbezogene Auskünfte erhalten und Angelegenheiten klären soll. Liegt keine Vollmacht vor, werden wir niemandem außer Ihnen Auskunft geben.',
      tileListIntro: 'So funktioniert es:',
      tileDot1: 'Klicken Sie auf den Button “Vollmacht verwalten” weiter unten.',
      tileDot2: 'Klicken Sie auf der Folgeseite “Vollmacht erteilen” am entsprechenden Vertragskonto.',
      tileDot3: 'Tragen Sie die Daten des Bevollmächtigten ein und bestätigen Sie Ihre Eingabe mit “Speichern”.',
      tileDot4: 'Im Anschluss wird Ihre Vollmacht am Vertragskonto angezeigt.',
      processIntro: 'Durch eine Vollmacht wollen wir Sie vor Datenmissbrauch durch Unbefugte schützen. Liegt keine Vollmacht vor, werden wir niemandem außer Ihnen (also auch keinem/keiner Ehepartner/-in oder Angehörigen) Auskunft geben.',
      dotIntro: 'Eine Vollmacht beinhaltet die Erlaubnis, in Ihrem Namen:',
      dot1: 'Auskünfte zu Stammdaten (Stammdaten sind: Vor- und Nachname, Akademischer Titel, Namenszusatz, Geburtsdatum, IBAN, Telefonnummer und E-Mail-Adresse, Rechnungsanschrift, Werbeeinverständnis) bzgl. des jeweiligen Vertrages einzuholen',
      dot2: 'Änderungen an diesen Stammdaten vorzunehmen',
      dot3: 'Einsicht in sämtliche Vertragsunterlagen zu nehmen',
      dot4: 'Beendigung des bestehenden Vertrages zu erklären und ein Angebot auf Abschluss eines neuen Vertrages abzugeben',
      processIntro2: 'Sie können Ihre Vollmacht jederzeit ohne Angabe von Gründen im Online Service oder in Textform widerrufen.',
      errors: {
        noVKsExistingForBP: 'Leider steht Ihnen der Prozess aufgrund Ihrer Vertragssituation nicht zur Verfügung.'
      },
      form: {
        name: 'Vorname',
        surname: 'Nachname',
        salutation: 'Anrede',
        addPerson: 'Vollmacht erteilen',
        areYouSure: 'Vollmacht entfernen?',
        yes: 'Ja',
        no: 'Nein',
        cancel: 'Abbrechen',
        delete: 'Entfernen',
        send: 'Speichern'
      },
      validation: {
        salutation: {
          required: 'Bitte geben Sie Ihre Anrede ein.'
        },
        name: {
          required: 'Bitte geben Sie Ihren Vornamen ein.'
        },
        surname: {
          required: 'Bitte geben Sie Ihren Nachnamen ein.'
        }
      }
    },
    signUp: {
      banner: {
        headerHighlights: 'Registrieren Sie sich jetzt bei Vattenfall',
        header: 'Registrieren'
      },
      salutation: 'Anrede',
      register: 'Registrierung',
      personalData: 'Persönliche Daten',
      registerText: 'Tragen Sie hier bitte Ihre persönlichen Daten ein und bestätigen Sie diese mit dem gelben Button „Weiter zur Aktivierung“.',
      registerTextPrefilled: 'Persönliche Daten“ information text “Überprüfen Sie bitte die vorgegebenen Daten in den Eingabefeldern und korrigieren Sie dieses gegebenenfalls. Bestätigen Sie anschließend Ihre Daten mit dem gelben Button „Weiter zur Aktivierung“.',
      registerTextEmail1: 'Zum Einrichten Ihres Accounts benötigen wir Ihre E-Mail-Adresse. Wir empfehlen, Ihre persönliche E-Mail-Adresse zu hinterlegen, damit nur Sie jederzeit direkten Zugriff auf Ihren Vertrag haben.',
      registerTextEmail2: 'Wir senden Ihnen Ihren Aktivierungscode, sobald Sie nach Überprüfung Ihrer Daten auf „Weiter zur Aktivierung" klicken.',
      privateEmail: 'Ihre Vorteile mit persönlicher E-Mail-Adresse',
      privateEmailBox1: '<b>Direkter Zugriff auf Ihre Vertrags-unterlagen</b> über unseren Online Service',
      privateEmailBox2: '<b>Wichtige Informationen erreichen Sie zuverlässing</b> ohne Drittanbieter',
      privateEmailBox3: '<b>Mehr Kontrolle über Ihre Daten</b> und keine Weitergabe an andere Unternehmen',
      firstName: 'Vorname',
      lastName: 'Nachname',
      button: 'Weiter zur Aktivierung',
      phone: 'Mobilfunknummer',
      email: 'E-Mail-Adresse',
      emailInfo: 'Ihre Eingabe wurde automatisch korrigiert. Alle Großbuchstaben wurden in Kleinbuchstaben umgewandelt, um eine einheitliche Verarbeitung zu ermöglichen.',
      emailHint: 'Die Vattenfall Europe Sales GmbH nutzt Ihre E-Mail-Adresse zur Vertragsanbahnung und -abwicklung im Rahmen unserer Online-Services. Darüber hinaus verwenden wir Ihre E-Mail-Adresse, um Sie im Rahmen der gesetzlichen Bestimmungen über eigene, ähnliche Energieprodukte und Dienstleistungen zu informieren. Falls Sie dies nicht wünschen, können Sie dem jederzeit per E-Mail an <a class="standard-link" href="mailto:werbewiderspruch@vattenfall.de">werbewiderspruch@vattenfall.de</a> widersprechen.',
      emailFootnote: '<sup>X1</sup> Zu diesem Zwecke gestatte ich der Vattenfall Europe Sales GmbH, die von mir erhobenen personenbezogenen Daten (Rufnummer, E-Mail-Adresse) zu verarbeiten. Meine Einwilligung in die Nutzung meiner Daten zu Werbezwecken ist für die Vertragserfüllung nicht erforderlich und gilt bis auf Widerruf, den ich jederzeit mit Wirkung für die Zukunft im Online Service auf <a class="standard-link" href="https://www.vattenfall.de">www.vattenfall.de</a> oder per Telefon unter 0800 9925 000 erklären kann. Überschneidungen mit bereits versandten Werbemitteilungen sind möglich. Im Falle des Widerrufs entstehen keine anderen Kosten als die Übermittlungskosten nach den Basistarifen.',
      dataPrivacy: 'Die Informationen zum Datenschutz können Sie {link} einsehen.',
      text: 'Bereits registriert?',
      linkToLogin: 'Zum Login',
      infoAboutCode: 'Den Aktivierungscode erhalten Sie per E-Mail. Bitte geben sie diesen und Ihr frei gewähltes Passwort ein.',
      validations: {
        dataPrivacy: {
          checked: 'Bitte bestätigen Sie, dass Sie die Informationen zum Datenschutz gelesen und akzeptiert haben.'
        },
        surname: {
          regex: 'Bitte geben Sie Ihren Nachnamen ein.'
        },
        name: {
          regex: 'Bitte geben Sie einen Vornamen ein.'
        },
        email: {
          regex: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
        },
        phone: {
          phoneNumberFormat: 'Bitte geben Sie eine gültige Telefonnummer.'
        },
        salutation: {
          required: 'Bitte geben Sie Ihre Anrede ein.'
        },
        username: {
          email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
          required: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
        },
        companyName: {
          regex: 'Geben Sie bitte eine gültige Firmierung mit maximal 35 Zeichen ein.'
        }
      }
    },
    accountActivation: {
      banner: 'Online Service - Nutzerprofil anlegen',
      infoText: 'Sie erhalten in wenigen Minuten eine E-Mail mit ihrem 8-stelligen Bestätigungscode, der unten eingetragen werden muss.',
      header: 'Aktivierungscode eingeben',
      headerText: 'Tragen Sie bitte diesen 8-stelligen Code aus der E-Mail und ein neues Passwort hier ein und bestätigen Sie Ihre Eingabe mit dem gelben Button  „Jetzt aktivieren“.',
      infoTxt: 'Als Nutzer des Online Service erhalten Sie alle vertragsbezogenen Dokumente online. Über neue Post im Portal informieren wir Sie selbstverständlich per E-Mail.',
      infoTextPhone: 'Zur Bestätigung Ihrer Mobilnummer erhalten Sie eine SMS mit einem 8-stelligen Aktivierungscode, der unten eingetragen werden muss.',
      headerTextPhone: 'Tragen Sie bitte diesen 8-stelligen Code aus Ihrer SMS hier ein und bestätigen Sie Ihre Eingabe mit dem gelben Button  „Jetzt aktivieren“.',
      email: 'E-Mail-Adresse',
      code: '8-stelliger Aktivierungscode',
      codeHint: 'Der 8-stellige Aktivierungscode, bestehend aus Großbuchstaben und Zahlen. Dieser wird ihnen innerhalb weniger Minuten per E-Mail zugesandt. Wenn Sie in Ihrem E-Mail-Postfach keine E-Mail mit dem Betreff „Aktivieren Sie Ihren Account“ finden, schauen Sie bitte in Ihrem Spam-Ordner nach.',
      codePhoneHint: 'Der 8-stellige Aktivierungscode, bestehend aus Großbuchstaben und Zahlen. Dieser wird Ihnen innerhalb weniger Minuten per SMS an Ihre Mobilfunknummer zugesandt. Sollte die SMS nach einigen Minuten nicht angekommen sein, überprüfen Sie bitte die eingegebene Mobilfunknummer.',
      password: 'Passwort',
      meterNumber: 'Zählernummer',
      repeatPassword: 'Passwortwiederholung',
      dataProtection1: 'Ich bestätige, dass ich die ',
      dataProtection2: ' gelesen und akzeptiert habe.',
      agb1: 'Ich akzeptiere die ',
      agb2: ' des Online Service.',
      dataProtection: 'Informationen zum Datenschutz',
      generalTermsAndCondidtions: 'Allgemeinen Geschäftsbedingungen',
      send: 'Jetzt aktivieren',
      validation: {
        repeatPassword: {
          required: 'Bitte wiederholen Sie das gewählte Passwort.',
          equal: 'Die eingegebenen Passwörter sind nicht identisch.'
        },
        email: {
          email: 'Bitte geben Sie hier Ihre E-Mail-Adresse ein.<br/>Beispiel: <strong>mustermann@mustermail.com</strong>',
          required: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
        },
        activationCode: {
          required: 'Aktivierungscode ist erforderlich.'
        },
        activationCodePhone: {
          required: 'Aktivierungscode ist erforderlich.'
        },
        password: {
          valid: 'Das Passwort muss zwischen 10 und 35 Zeichen lang sein.',
          required: 'Bitte wählen Sie ein Passwort.'
        },
        agb: {
          checked: 'Bitte bestätigen Sie, dass Sie die AGB zur Nutzung des Online Service akzeptieren.'
        },
        dataProtection: {
          checked: 'Bitte bestätigen Sie, dass Sie die Informationen zum Datenschutz gelesen und akzeptiert haben.'
        }
      }
    },
    contactForm: {
      header: 'Senden Sie uns eine Nachricht',
      subheader: 'Nutzen Sie dieses Formular, um uns eine gesicherte E-Mail zu senden. Sie erhalten eine Bestätigung an Ihre E-Mail-Adresse. Ihre Mitteilung wird aus Datenschutzgründen nicht darin enthalten sein. Diese können Sie jedoch nach dem Absenden speichern.',
      hint: 'Unser Tipp: Nutzen Sie nach Auswahl des Kontaktgrundes den jeweils angebotenen Onlineservice.',
      contactReason: 'Thema',
      message: 'Ihre Mitteilung',
      attachDocument: 'Dokument anfügen',
      attachDocumentHint: 'Sie haben die Möglichkeit bis zu drei Dokumente mitzuschicken (maximale Größe 10 MB). Dateinamen sollten keine Leerzeichen enthalten. Sie können folgende Dateiformate hochladen: pdf, doc, docx, xls, xlsx, jpg, gif, png, zip.',
      areYouACustomer: 'Haben Sie ein Anliegen zu einem bereits abgeschlossenen Vertrag?',
      isCustomerInfo: 'Hinweis: Eingehende Anliegen bearbeiten wir immer schnellstmöglich. Sehen Sie daher bitte von Erinnerungsnachrichten zu Ihrem Anliegen ab. Vielen Dank!<br /><br />Falls Sie nicht selbst Vertragsinhaber sind, brauchen Sie eine Vollmacht, um Auskunft zu erhalten. So schützen wir unsere Kunden vor Datenmissbrauch durch Unbefugte. Die Vollmacht können Sie unter <a class="standard-link" href="https://www.vattenfall.de/vollmacht">vattenfall.de/vollmacht</a> erteilen.',
      personalData: 'Persönliche Daten',
      salutation: 'Anrede',
      firstname: 'Vorname',
      lastname: 'Name',
      companyName1: 'Firmierung',
      companyName2: 'Firmierung Zusatz',
      contractAccountNumber: 'Vertragskontonummer',
      email: 'E-Mail-Adresse',
      phone: 'Telefonnummer tagsüber',
      zipcode: 'Postleitzahl',
      city: 'Ort',
      agreement: 'Die Informationen zum Datenschutz können Sie <a class="standard-link" target="_blank" href="//vattenfall.de/datenschutz">in unseren Datenschutzinformationen</a> einsehen.',
      cancel: 'Abbrechen',
      submit: 'Absenden',
      attachment: 'Anhang',
      confirmation: 'Vielen Dank für Ihre Nachricht',
      requestSent: 'Ihre Anfrage wurde an unseren Kundenservice geleitet.',
      warningLabel: 'Hinweis:',
      warningText: 'Ihre Mitteilung darf aus Datenschutzgründen nicht in Ihrer Bestätigungsmail enthalten sein. Sie können jedoch den Inhalt Ihrer Anfrage auf dieser Seite drucken.',
      contactInfo: 'Ihre Nachricht an uns:',
      validations: {
        attachment: {
          minimumFileSizeValidator: 'Das Dokument enthält keine Daten und kann nicht angefügt werden.',
          fileSizeValidator: 'Anhänge dürfen die Größe von 10 MB nicht überschreiten.',
          fileTypes: 'Dieses Dateiformat wird nicht unterstützt. Nutzen Sie bitte nur: pdf, doc, docx, xls, xlsx, jpg, gif, png, zip.'
        },
        contactReason: {
          required: 'Bitte wählen Sie aus.'
        },
        message: {
          required: 'Bitte füllen Sie dieses Feld aus.'
        },
        salutation: {
          required: 'Bitte geben Sie Ihre Anrede ein.'
        },
        contractAccountNumber: {
          regex: 'Ihre Vertragskontonummer besteht nur aus Ziffern und beginnt mit 83.'
        },
        email: {
          email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
          required: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
        },
        phone: {
          phoneNumberFormat: 'Bitte geben Sie eine gültige Telefonnummer.'
        },
        zipcode: {
          regex: 'Bitte geben Sie eine gültige Postleitzahl.'
        },
        city: {
          required: 'Bitte geben Sie Ihren Ort ein.'
        },
        agreement: {
          checked: ''
        }
      }
    },
    logout: {
      text: 'Wir melden Sie ab...'
    },
    tariffComponent: {
      header: 'Ihr Auftrag im Überblick',
      contractDuration: 'Mindestvertragslaufzeit',
      contractExtension: 'Vertragsverlängerung',
      resignationPeriod: 'Kündigungsfrist',
      bonus: 'Bonus',
      bonusDetails: 'Sonderangebote/Zusatzleistungen',
      priceDetails: 'Aufschlüsselung der Preisbestandteile',
      meterFeeInfo: 'Das Entgelt Zähler gilt für eine konventionelle Messeinrichtung. Je nach eingebauter Zählerart ergeben sich unterschiedliche Kosten. Weitere Informationen finden Sie',
      here: 'hier.',
      consumptionAnnual1: 'bei ',
      consumptionAnnual2: ' kWh',
      consumptionAnnual3: ' Jahresverbrauch',
      meterFee: 'Entgelt Zähler',
      priceConsumptionSingle: 'Verbrauchspreis',
      priceConsumptionHigh: 'Verbrauchspreise HT',
      priceConsumptionNormal: 'Verbrauchspreise NT',
      priceAnnual: 'Jahrespreis',
      priceOnce: 'Einmalpreis',
      priceBase: 'Grundpreis',
      tariffIncludingFee: 'Tarif inkl. Entgelt Messstellenbetrieb',
      contractStart: 'Vertragsbeginn',
      contractTermination: 'Vertragsbeendigung',
      cancellationNextPossibleDate: 'Nächstmöglicher Kündigungstermin',
      cancellationForm: 'Kündigungsform',
      cancellationConfirmation: 'Kündigungsbestätigung',
      priceGuarantee: 'Preisgarantie',
      onlineTariff: 'Online-Tarif',
      euro: '€',
      euroPerMonth: '€/Monat',
      centPerKwh: 'Cent/kWh',
      month: '/Monat',
      moreInfo: {
        expand: 'Tarifdetails anzeigen',
        collapse: 'Tarifdetails ausblenden'
      },
      dynamicTariff: {
        spotprice: 'Spotmarktpreis',
        spotvalue: 'dynamisch in Cent/kWh',
        transitionalprice: 'Übergangspreis',
        transitionalvalue: 'Ø-Börsenpreis in Cent/kWh',
        maxLimit: 'Höchstpreislimit',
        minLimit: 'Tiefstpreislimit',
        info: 'für den Börsenpreis je Viertelstunde'
      },
      orderButton: 'Jetzt wechseln'
    },
    tariffChange: {
      banner: 'Tarifwechsel',
      moreInfo: {
        expand: 'Tarifdetails anzeigen',
        collapse: 'Tarifdetails ausblenden'
      },
      noProductsText: 'Aktuell können wir Ihnen keine Wechseltarife anbieten.',
      order: 'Jetzt wechseln',
      selectChangeDate: 'Wechseltermin festlegen',
      phoneHeader: 'Wir benötigen Ihre Telefonnummer',
      phone: 'Mobilfunknummer',
      phoneHint: 'Um die Sicherheit bei der Nutzung unserer Online Services zu erhöhen, setzen wir vermehrt auf eine zusätzliche Schutzmaßnahme: den SMS-Sicherheitscode. Teilen Sie uns daher am besten schon jetzt Ihre Mobilnummer dafür mit.',
      birthdateHeader: 'Bitte geben Sie Ihr Geburtsdatum ein',
      birthdate: 'Geburtsdatum',
      submit: 'Zahlungspflichtig bestellen',
      print: 'Zusammenfassung drucken',
      backToProductsList: 'Zurück zur Tarifauswahl',
      thankYouPage: {
        header: 'Vielen Dank. Wir haben Ihre Tarifänderung erhalten.',
        nextSteps: 'Wie geht es jetzt weiter?',
        pointOne: '<p>Ihr Auftrag wird nun bearbeitet. In Kürze erhalten Sie eine Bestätigung per E-Mail. </p>',
        pointTwo: '<p>Ihr Tarifwechsel erfolgt nach Ihrem Wunsch zum {changeDate}.</p>',
        expandButton: 'Vertragsdaten anzeigen',
        collapseButton: 'Vertragsdaten schließen',
        backButton: 'Zur Startseite'
      },
      validations: {
        agreement: {
          checked: 'Bitte bestätigen Sie Ihr Einverständnis.'
        },
        changeDate: {
          required: 'Bitte wählen Sie einen Wechseltermin.'
        },
        phone: {
          required: 'Bitte geben Sie eine gültige Telefonnummer ein.',
          phoneNumberFormat: 'Das Format der Telefonnummer ist ungültig.'
        },
        birthdate: {
          required: 'Bitte geben Sie Ihr Geburtsdatum ein.'
        }
      }
    },
    maintenance: {
      title: 'Wartungsarbeiten',
      paragraph1: 'Sehr geehrter Besucher,',
      paragraph2: 'aufgrund von Optimierungsarbeiten ist unser Online Service derzeit nicht verfügbar. In Kürze sind wir mit unseren Services wieder wie gewohnt für Sie da.',
      paragraph3: 'Wir bitten um Ihr Verständnis.'
    },
    genericPage: {
      header: 'Meinen Code eingeben',
      subheader: 'Geben Sie bitte Ihren 8-stelligen Code ein.',
      securityCheck: 'Sicherheitsprüfung',
      code: 'Code',
      zipcode: 'Postleitzahl',
      submit: 'Senden',
      validation: {
        code: {
          required: 'Code ist erforderlich.'
        },
        zipcode: {
          required: 'Postleitzahl ist erforderlich.',
          length: 'Bitte geben Sie 5 Ziffern ein.'
        }
      },
      signUp: {
        banner: 'Persönlichen Zugang aktivieren',
        registerText: 'Überprüfen Sie bitte die vorgegebenen Daten in den Eingabefeldern und korrigieren Sie dieses gegebenenfalls. Bestätigen Sie anschließend Ihre Daten mit dem gelben Button „Weiter zur Aktivierung“.',
        email: 'E-Mail-Adresse',
        emailHint: "Die Vattenfall Europe Sales GmbH nutzt Ihre E-Mail-Adresse zur Vertragsanbahnung und -abwicklung im Rahmen unserer Online-Services. Darüber hinaus verwenden wir Ihre E-Mail-Adresse, um Sie im Rahmen der gesetzlichen Bestimmungen über eigene, ähnliche Energieprodukte und Dienstleistungen zu informieren. Falls Sie dies nicht wünschen, können Sie dem jederzeit per E-Mail <a class=\"standard-link\" href={'mailto:werbewiderspruch@vattenfall.de'}>{'werbewiderspruch@vattenfall.de'}</a> widersprechen.",
        privacyText: 'Um die Umwelt zu schonen, finden Sie unter <a class="standard-link" target="_blank" href="//vattenfall.de/datenschutz">vattenfall.de/datenschutz</a> unsere aktuellen Datenschutzinformationen.<br />Auf Wunsch senden wir sie Ihnen auch gern per Post zu.',
      },
      login: {
        text: 'Sie sind bereits registriert? Loggen Sie sich hier ein.'
      }
    },
    footer: {
      cancelContract: 'Verträge hier kündigen',
      revokeContract: 'Verträge hier widerrufen',
      tariffsAndOffers: 'Tarife & Angebote',
      onlineServices: 'Online Services',
      vattenfallOffers: 'Vattenfall Angebote',
      otherLanguages: 'Andere Sprachen',
      aboutVattenfall: 'Über Vattenfall',
      electricityTariifs: 'Stromtarife',
      gasTariffs: 'Gastarife',
      heatTariffs: 'Wärmetarife',
      electricityForCars: 'Strom für Elektroautos',
      smartHome: 'Smart Home',
      reportMove: 'Umzug melden',
      enterMeterReading: 'Zählerstand mitteilen',
      changePartPayment: 'Abschläge ändern',
      changeTariff: 'Tarif wechseln',
      reportFault: 'Störung melden',
      vacancyPortal: 'Leerstandsportal',
      myHighlights: 'my Highlights',
      vattenfallShop: 'Vattenfall Shop',
      tellAFriend: 'Freunde werben',
      forEnergyCompanies: 'Für Energieunternehmen',
      infoWorldEnergy: 'Infowelt Energie',
      bewareOfFrauds: 'Betrugsverdacht melden',
      latePayment: 'Zahlungsverzug',
      sustainability: 'Nachhaltigkeit',
      energyInFocus: 'Energie im Fokus',
      newsroom: 'Newsroom',
      career: 'Karriere',
      accessibility: 'Barrierefreiheit',
      imprint: 'Impressum',
      termsOfService: 'Nutzungsbedingungen',
      privacy: 'Datenschutz',
      glossary: 'Glossar',
      contact: 'Hilfe & Kontakt',
      cookieSettings: 'Cookie-Einstellungen',
      faq: 'Fragen & Antworten',
      saveEnergy: 'Energie sparen',
      inside: 'Inside Vattenfall',
      deutschland: 'Vattenfall Deutschland',
      group: 'Vattenfall Group',
      climate: 'Klimaneutrale Website'
    },
    notFoundPage: {
      header: 'Die Seite, nach der Sie suchen, konnte nicht gefunden werden.',
      subheader: 'Vielleicht können Sie den von Ihnen gewünschten Inhalt über die Startseite finden.',
      button: 'Zur Startseite'
    },
    dynamicTariffs: {
      banner: 'Verbrauch und Kosten',
      title: 'Aktuelle Informationen zu den Börsenstrompreisen und Verbräuchen',
      meter: 'Zählernummer',
      location: 'Marktlokations-ID',
      day: 'Tag',
      week: 'Woche',
      month: 'Monat',
      date: 'Datum',
      send: 'Neu berechnen',
      consumption: 'Verbrauch',
      price: 'Börsenpreis',
      prices: 'Börsenpreise',
      usage: 'Verbrauch und Kosten',
      hint1: 'Aktuelle Informationen zu den Börsenstrompreisen finden Sie <a class="standard-link" target="_blank" href="https://www.vattenfall.de/strom/tarife/oekostrom-dynamik-boersenpreise">hier</a>.',
      hint2: 'Eine detaillierte Berechnung des Spotmarktpreises des jeweiligen Liefermonats (auf Stundenbasis) können Sie zum Ende des Kalendermonats runterladen bzw. einsehen',
      currentMonthHint: 'Die für den betreffenden Tag geltenden Börsenpreise werden immer am Vortag zwischen 12 und 15 Uhr veröffentlicht',
      priceMax: 'Höchstpreislimit: {PriceMax} Cent/kWh brutto ({PriceMaxNetto} Cent/kWh netto)',
      priceMin: 'Tiefstpreislimit: {PriceMin} Cent/kWh brutto ({PriceMinNetto} Cent/kWh netto)',
      empty: 'Für den ausgewählten Zeitraum sind keine Daten verfügbar.',
      excelFile: {
        headline: 'Detaillierte Berechnung des Spotmarktpreises {MonatUndJahr}',
        button: 'Excel-Export herunterladen',
        name: 'Daten_',
        column1: 'Liefertag',
        column2: 'Lieferviertelstunde',
        column3: 'Verbrauch in kWh',
        column4: 'Börsenpreis in Cent/kWh',
        column4WithLimit: 'Börsenpreis in Cent/kWh (netto), ggf. korrigiert um Preislimit',
        column5: 'Börsenpreisabhängige Kosten in Euro (netto), Verbrauch in Lieferviertelstunde x Börsenpreis',
        text1: 'Verbrauchsabhängige Kosten für alle Lieferviertelstunden anhand der Börsenpreise in Euro (netto): {SummeKostenBrutto}',
        text2: 'Gesamtsumme des Verbrauchs in kWh: {Arbeit}',
        text3: 'Spotmarktpreis zzgl. Umsatzsteuer für {MonatUndJahr} in Cent/kWh: {PreisMengengewichtetBrutto}',
        text4: 'Spotmarktpreis für {MonatUndJahr} in Cent/kWh (netto): {PreisMengengewichtet}',
      },
      validations: {
        required: 'Bitte geben Sie das Datum im Format TT.MM.JJJJ ein.',
        min: 'Bitte geben Sie ein Datum bis einschließlich {value} ein.',
        max: 'Bitte geben Sie ein Datum ab dem {value} ein.'
      }
    },
    tariffOffer: {
      headline: "Unsere Empfehlung",
      text1: "Wir freuen uns, dass Sie Kunde bei uns sind und möchten Sie gerne halten.",
      text2: "Jetzt neuen Tarif wählen und Treue-Bonus sichern!",
      submit: "Zum Angebot",
      dashboardText1: "Verlängern Sie jetzt Ihren Energievertrag und sichern Sie sich vorteilhafte Konditionen sowie eine langfristige Preisgarantie.",
      dashboardText2: "Jetzt neuen Tarif wählen und Treuevorteil sichern!",
      heatpumpHeader: "Auf Wärmepumpe umsteigen",
      heatpumpText1: "<strong>Wir begleiten Sie:</strong> persönliche Beratung, individuelle Planung, kostenloser Förderservice und fachgerechte Installation.",
      heatpumpLinkText: "Jetzt Angebot sichern",
    },
    tokenOverview: {
      header: 'Sitzungen abmelden',
      hint: 'Hier können Sie sich von laufenden Sitzungen in zugehörigen Apps und Portalen abmelden, die auf Ihren Account zugreifen.',
      name: 'Name',
      validUntil: 'Gültig bis',
      delete: 'Zugriff entfernen',
      currentSession: 'Aktuelle Sitzung'
    },
    userPopup: {
      text1: 'Passen Sie bitte unbedingt Ihren Benutzernamen an!',
      text2: 'Bisher nutzen Sie für Ihren Account als Benutzernamen keine E-Mail-Adresse.',
      text3: 'Ändern Sie Ihren Benutzernamen unbedingt bis zum 30. April 2025 hier in eine E-Mail-Adresse, damit Sie Ihren Account mit allen Vorteilen auch weiterhin nutzen können.',
      text4: 'Falls Sie einen weiteren Benutzeraccount nutzen möchten, müssen Sie für diesen eine andere E-Mail-Adresse vergeben.',
      text5: 'Sollten Sie bis Ende April 2025 keine Anpassung vorgenommen haben, müssen wir Ihren Account leider löschen.',
      here: 'hier'
    },
    domainPopup: {
      headline: 'E-Mail-Adresse ändern',
      text1: 'Guten Tag,',
      text2: 'schön, dass wir Sie mit unserer Energie versorgen. Da Sie über Check24 zu uns gekommen sind, liegt uns bisher nur Ihre E-Mail-Adresse für Check24 vor. Damit Sie Ihre persönlichen Daten und Informationen sicher, direkt und schnell von uns erhalten, empfehlen wir Ihnen dringend, Ihre eigene E-Mail-Adresse bei uns zu hinterlegen. Bei Ihrem CHECK24-Account bleibt alles unverändert.',
      text3: 'Hier können Sie Ihre E-Mail-Adresse für uns hinterlegen:',
      link: 'Benutzerprofil'
    },
    anonymizedHint: {
      textFull: 'Ihre Vertragskontonummer können wir aus Datenschutzgründen hier nicht vollständig anzeigen. Falls Sie die vollständige Vertragskontonummer suchen, finden Sie diese in Ihren Vertragsdokumenten, z.B. Ihrer Rechnung oder Vertragsbestätigung, in Ihrem <a class="standard-link" href="/postfach">Postfach</a>. Wenn Sie mehrere Verträge haben, wählen Sie zunächst auf der Übersichtsseite den entsprechenden Vertrag im gelben Auswahlelement oben rechts aus. Öffnen Sie dann Ihr Postfach und klicken Sie bei einem Vertragsdokument auf „Dokument anzeigen“.',
      textShort: 'Ihre Vertragskontonummer können wir aus Datenschutzgründen hier nicht vollständig anzeigen. Falls Sie die vollständige Vertragskontonummer suchen, finden Sie diese in Ihren Vertragsdokumenten, z.B. Ihrer Rechnung oder Vertragsbestätigung, in Ihrem <a class="standard-link" href="/postfach">Postfach</a>. Wenn Sie mehrere Verträge haben, ...',
      showLess: "Weniger anzeigen",
      showMore: "Alles anzeigen"
    },
    missingData: {
      headline: 'Sicher und jederzeit verfügbar',
      birthdayMissingText: 'Um die Sicherheit bei der Nutzung unserer Online Services weiter zu erhöhen, nutzen wir zukünftig zur Authentifizierung auch das Geburtsdatum. Dies können Sie uns hier gleich mitteilen:',
      birthdayMissingButton: 'Jetzt Geburtsdatum eingeben',
      phoneMissingText: 'Um die Sicherheit bei der Nutzung unseres Online Services zu erhöhen, setzen wir vermehrt auf eine zusätzliche Schutzmaßnahme: den SMS-Sicherheitscode. Teilen Sie uns dazu bitte Ihre Mobilnummer mit, damit auch Sie von dieser Verbesserung profitieren können.',
      phoneMissingButton: 'Jetzt Mobilnummer eingeben',
      birthdate: 'Ihr Geburtsdatum',
      validations: {
        birthdate: {
          required: 'Bitte geben Sie Ihr Geburtsdatum ein.'
        }
      }
    },
    einvoice: {
      banner: {
        title: 'Rechnung per E-Mail bestellen',
        editTitle: 'Rechnung per E-Mail ändern',
        subtitle: 'E-Rechnung',
        contractAccount: 'Vertragskonto',
        tariff: 'Tarif',
        cancel: 'Rechnung per E-Mail abbestellen'
      },
      intro: 'Der Versand kann mit oder ohne Passwortschutz erfolgen. Bei Zustellproblemen wird die Rechnung automatisch per Post verschickt.',
      form: {
        recipent: 'Empfänger',
        recipentLabel: 'E-Mail-Adresse',
        subject: 'Betreff der E-Mails',
        subjectLabel: 'Betreffvorschläge',
        password: 'Passwortschutz',
        passwordInfo: 'Ohne Passwortschutz erhöht sich das Risiko, dass Unbefugte auf Ihre Rechnungsdaten zugreifen.<br><strong>Hinweis für Gewerbekunden:</strong> Die Aktivierung des Passwortschutzes unterbindet eine automatische Weiterverarbeitung Ihrer Rechnung im XML-Format.',
        passwordLabel: 'Passwort',
        passwordRepeatLabel: 'Passwort wiederholen',
        passwordCheckbox: 'Passwortschutz aktivieren',
        consentCheckboxPrivate: 'Ich möchte künftig meine Rechnungen per E-Mail erhalten. Dies gilt für alle Energielieferverträge, die derzeitig oder zukünftig zwischen mir und der Vattenfall Europe Sales GmbH bestehen. Ich verpflichte mich, die Vattenfall Europe Sales GmbH im Falle einer Änderung meiner E-Mail-Adresse unverzüglich zu informieren und regelmäßig meinen Spam-Ordner zu kontrollieren. Soweit die Energielieferverträge eine Hinterlegung von Rechnungen im Online Service-Portal vorsehen, erfolgt diese zusätzlich zur Übersendung der Rechnung per E-Mail. Meine Wahl der Rechnung per E-Mail gilt bis auf Widerruf.',
        consentCheckboxBusiness: 'Ich erkläre in Vollmacht für mein Unternehmen, dass dieses künftig die Rechnungen per E-Mail erhalten möchte. Dies gilt für alle Energielieferverträge unter den ausgewählten Geschäftspartnern, die zwischen meinem Unternehmen und der Vattenfall Europe Sales GmbH bestehen. Mein Unternehmen verpflichtet sich, die Vattenfall Europe Sales GmbH im Falle einer Änderung seiner E-Mail-Adresse unverzüglich zu informieren und regelmäßig seinen Spam-Ordner zu kontrollieren. Soweit die Energielieferverträge eine Hinterlegung von Rechnungen im Online Service-Portal vorsehen, erfolgt diese zusätzlich zur Übersendung der Rechnung per E-Mail.',
        confirmationCode: '8-stelliger Code',
        confirmationCodeHint: 'Tragen Sie bitte diesen 8-stelligen Code aus der E-Mail hier ein und bestätigen Ihre Eingabe mit dem gelben Button „Weiter zur Verifizierung“.',
        changePassword: 'Passwort ändern',
        cancel: 'Rechnung per E-Mail nicht mehr erhalten'
      },
      validations: {
        subject: {
          required: 'Bitte wählen Sie aus.'
        },
        consent: {
          checked: 'Bitte bestätigen Sie Ihr Einverständnis.'
        },
        password: {
          required: 'Bitte wählen Sie ein Passwort.',
          valid: 'Das Passwort muss zwischen 10 und 35 Zeichen lang sein.'
        },
        passwordRepeat: {
          required: 'Bitte wiederholen Sie das gewählte Passwort.',
          inequal: 'Die eingegebenen Passwörter sind nicht identisch.'
        },
        code: {
          required: 'Code ist erforderlich.',
          regex: 'Bitte geben Sie einen gültigen 8-stelligen Code ein.'
        }
      },
      fa2: {
        header: 'Authentifizierung',
        hint: 'Sie erhalten in wenigen Minuten eine E-Mail mit ihrem 8-stelligen Aktivierungscode, der unten eingetragen werden muss.'
      },
      submit: 'Weiter zur Verifizierung',
      edit: 'Änderungen speichern',
      cancel: {
        header: 'Rechnung per E-Mail abbestellen?',
        info: 'Sind Sie sicher, dass Sie den Service <strong><i>Rechnung per E-Mail</i></strong> abbestellen möchten? Sie erhalten Ihre Rechnungen in dem Fall wieder wie vor dem Abonnement. Ihre Rechnungen können Sie auch weiterhin jederzeit in Ihrem Postfach einsehen und werden über den Erhalt einer neuen Rechnung jeweils per E-Mail informiert.',
        submit: 'Jetzt abbestellen'
      },
      sentPage: {
        header: 'Rechnung per E-Mail wurde erfolgreich bestellt.',
        headerUpdated: 'Ihre Rechnung per E-Mail wurde erfolgreich geändert.',
        headerCanceled: 'Ihre Rechnung per E-Mail wurde erfolgreich abbestellt.',
        text: 'Ab sofort erhalten Sie Ihre Rechnung zusätzlich als PDF per E-Mail an die angegebene Adresse.<br />Alle Rechnungen werden auch weiterhin in Ihrem Rechnungs-Postfach für Sie hinterlegt.',
        textUpdated: 'Sie erhalten wie bisher Ihre Rechnung zusätzlich als PDF per E-Mail an die angegebene Adresse.<br />Alle Rechnungen werden auch weiterhin in Ihrem Rechnungspostfach für Sie hinterlegt.',
        textCanceled: 'Sie erhalten Ihre Rechnungen wieder wie vor der Bestellung der <i>Rechnung per E-Mail</i>.<br /> Ihre Rechnungen können Sie auch weiterhin jederzeit in Ihrem Postfach einsehen und werden über den Erhalt einer neuen Rechnung jeweils per E-Mail informiert.',
        backButton: 'Zur Startseite'
      }
    }
  }
}
export default messages
